
import React from "react"
import styled, { css } from "styled-components"
import { space, color, layout, system } from "styled-system"

import AccessApi from "./svg/access-api.svg"
import Alert from "./svg/alert.svg"
import Api from "./svg/api.svg"
import ArrowBottom from "./svg/arrow-bottom.svg"
import ArrowLeft from "./svg/arrow-left.svg"
import ArrowRight from "./svg/arrow-right.svg"
import ArrowTop from "./svg/arrow-top.svg"
import Arrow from "./svg/arrow.svg"
import Bitbucket from "./svg/bitbucket.svg"
import Book from "./svg/book.svg"
import Calendar from "./svg/calendar.svg"
import Chart from "./svg/chart.svg"
import CleanProducts from "./svg/clean-products.svg"
import ClockBlack from "./svg/clock-black.svg"
import Clock from "./svg/clock.svg"
import ContentIndex from "./svg/content-index.svg"
import Arn from "./svg/context/arn.svg"
import EProtein from "./svg/context/e-protein.svg"
import GlycoproteicMembrane from "./svg/context/glycoproteic-membrane.svg"
import NProtein from "./svg/context/n-protein.svg"
import SProtein from "./svg/context/s-protein.svg"
import CoronavirusIlu from "./svg/coronavirusIlu.svg"
import Dashboard from "./svg/dashboard.svg"
import DataIco from "./svg/data-ico.svg"
import DistancedCat from "./svg/distanced-cat.svg"
import DistancedMan from "./svg/distanced-man.svg"
import DistancedWoman from "./svg/distanced-woman.svg"
import Download from "./svg/download.svg"
import Drag from "./svg/drag.svg"
import File from "./svg/file.svg"
import FirstCovidContact from "./svg/first-covid-contact.svg"
import FlagOms from "./svg/flag-oms.svg"
import FlagAd from "./svg/flags/flag-ad.svg"
import FlagAe from "./svg/flags/flag-ae.svg"
import FlagAf from "./svg/flags/flag-af.svg"
import FlagAg from "./svg/flags/flag-ag.svg"
import FlagAi from "./svg/flags/flag-ai.svg"
import FlagAl from "./svg/flags/flag-al.svg"
import FlagAm from "./svg/flags/flag-am.svg"
import FlagAo from "./svg/flags/flag-ao.svg"
import FlagAr from "./svg/flags/flag-ar.svg"
import FlagAs from "./svg/flags/flag-as.svg"
import FlagAt from "./svg/flags/flag-at.svg"
import FlagAu from "./svg/flags/flag-au.svg"
import FlagAw from "./svg/flags/flag-aw.svg"
import FlagAx from "./svg/flags/flag-ax.svg"
import FlagAz from "./svg/flags/flag-az.svg"
import FlagBa from "./svg/flags/flag-ba.svg"
import FlagBb from "./svg/flags/flag-bb.svg"
import FlagBd from "./svg/flags/flag-bd.svg"
import FlagBe from "./svg/flags/flag-be.svg"
import FlagBf from "./svg/flags/flag-bf.svg"
import FlagBg from "./svg/flags/flag-bg.svg"
import FlagBh from "./svg/flags/flag-bh.svg"
import FlagBi from "./svg/flags/flag-bi.svg"
import FlagBj from "./svg/flags/flag-bj.svg"
import FlagBm from "./svg/flags/flag-bm.svg"
import FlagBn from "./svg/flags/flag-bn.svg"
import FlagBo from "./svg/flags/flag-bo.svg"
import FlagBq from "./svg/flags/flag-bq.svg"
import FlagBr from "./svg/flags/flag-br.svg"
import FlagBs from "./svg/flags/flag-bs.svg"
import FlagBt from "./svg/flags/flag-bt.svg"
import FlagBw from "./svg/flags/flag-bw.svg"
import FlagBy from "./svg/flags/flag-by.svg"
import FlagBz from "./svg/flags/flag-bz.svg"
import FlagCa from "./svg/flags/flag-ca.svg"
import FlagCc from "./svg/flags/flag-cc.svg"
import FlagCd from "./svg/flags/flag-cd.svg"
import FlagCf from "./svg/flags/flag-cf.svg"
import FlagCg from "./svg/flags/flag-cg.svg"
import FlagCh from "./svg/flags/flag-ch.svg"
import FlagCi from "./svg/flags/flag-ci.svg"
import FlagCk from "./svg/flags/flag-ck.svg"
import FlagCl from "./svg/flags/flag-cl.svg"
import FlagCm from "./svg/flags/flag-cm.svg"
import FlagCn from "./svg/flags/flag-cn.svg"
import FlagCo from "./svg/flags/flag-co.svg"
import FlagCr from "./svg/flags/flag-cr.svg"
import FlagCu from "./svg/flags/flag-cu.svg"
import FlagCv from "./svg/flags/flag-cv.svg"
import FlagCw from "./svg/flags/flag-cw.svg"
import FlagCx from "./svg/flags/flag-cx.svg"
import FlagCz from "./svg/flags/flag-cz.svg"
import FlagDe from "./svg/flags/flag-de.svg"
import FlagDj from "./svg/flags/flag-dj.svg"
import FlagDk from "./svg/flags/flag-dk.svg"
import FlagDm from "./svg/flags/flag-dm.svg"
import FlagDo from "./svg/flags/flag-do.svg"
import FlagDz from "./svg/flags/flag-dz.svg"
import FlagEcW from "./svg/flags/flag-ec-w.svg"
import FlagEc from "./svg/flags/flag-ec.svg"
import FlagEe from "./svg/flags/flag-ee.svg"
import FlagEg from "./svg/flags/flag-eg.svg"
import FlagEh from "./svg/flags/flag-eh.svg"
import FlagEr from "./svg/flags/flag-er.svg"
import FlagEsAn from "./svg/flags/flag-es-an.svg"
import FlagEsAr from "./svg/flags/flag-es-ar.svg"
import FlagEsAs from "./svg/flags/flag-es-as.svg"
import FlagEsCb from "./svg/flags/flag-es-cb.svg"
import FlagEsCe from "./svg/flags/flag-es-ce.svg"
import FlagEsCl from "./svg/flags/flag-es-cl.svg"
import FlagEsCm from "./svg/flags/flag-es-cm.svg"
import FlagEsCn from "./svg/flags/flag-es-cn.svg"
import FlagEsCt from "./svg/flags/flag-es-ct.svg"
import FlagEsEx from "./svg/flags/flag-es-ex.svg"
import FlagEsGa from "./svg/flags/flag-es-ga.svg"
import FlagEsIb from "./svg/flags/flag-es-ib.svg"
import FlagEsMc from "./svg/flags/flag-es-mc.svg"
import FlagEsMd from "./svg/flags/flag-es-md.svg"
import FlagEsMl from "./svg/flags/flag-es-ml.svg"
import FlagEsNc from "./svg/flags/flag-es-nc.svg"
import FlagEsPv from "./svg/flags/flag-es-pv.svg"
import FlagEsRi from "./svg/flags/flag-es-ri.svg"
import FlagEsVc from "./svg/flags/flag-es-vc.svg"
import FlagEs from "./svg/flags/flag-es.svg"
import FlagEt from "./svg/flags/flag-et.svg"
import FlagEu from "./svg/flags/flag-eu.svg"
import FlagFi from "./svg/flags/flag-fi.svg"
import FlagFj from "./svg/flags/flag-fj.svg"
import FlagFk from "./svg/flags/flag-fk.svg"
import FlagFm from "./svg/flags/flag-fm.svg"
import FlagFr from "./svg/flags/flag-fr.svg"
import FlagGa from "./svg/flags/flag-ga.svg"
import FlagGb from "./svg/flags/flag-gb.svg"
import FlagGd from "./svg/flags/flag-gd.svg"
import FlagGe from "./svg/flags/flag-ge.svg"
import FlagGg from "./svg/flags/flag-gg.svg"
import FlagGh from "./svg/flags/flag-gh.svg"
import FlagGi from "./svg/flags/flag-gi.svg"
import FlagGl from "./svg/flags/flag-gl.svg"
import FlagGm from "./svg/flags/flag-gm.svg"
import FlagGn from "./svg/flags/flag-gn.svg"
import FlagGq from "./svg/flags/flag-gq.svg"
import FlagGr from "./svg/flags/flag-gr.svg"
import FlagGt from "./svg/flags/flag-gt.svg"
import FlagGu from "./svg/flags/flag-gu.svg"
import FlagGw from "./svg/flags/flag-gw.svg"
import FlagHk from "./svg/flags/flag-hk.svg"
import FlagHn from "./svg/flags/flag-hn.svg"
import FlagHr from "./svg/flags/flag-hr.svg"
import FlagHt from "./svg/flags/flag-ht.svg"
import FlagHu from "./svg/flags/flag-hu.svg"
import FlagId from "./svg/flags/flag-id.svg"
import FlagIe from "./svg/flags/flag-ie.svg"
import FlagIl from "./svg/flags/flag-il.svg"
import FlagIm from "./svg/flags/flag-im.svg"
import FlagIn from "./svg/flags/flag-in.svg"
import FlagIo from "./svg/flags/flag-io.svg"
import FlagIq from "./svg/flags/flag-iq.svg"
import FlagIr from "./svg/flags/flag-ir.svg"
import FlagIs from "./svg/flags/flag-is.svg"
import FlagIt from "./svg/flags/flag-it.svg"
import FlagJe from "./svg/flags/flag-je.svg"
import FlagJm from "./svg/flags/flag-jm.svg"
import FlagJo from "./svg/flags/flag-jo.svg"
import FlagJp from "./svg/flags/flag-jp.svg"
import FlagKe from "./svg/flags/flag-ke.svg"
import FlagKg from "./svg/flags/flag-kg.svg"
import FlagKh from "./svg/flags/flag-kh.svg"
import FlagKi from "./svg/flags/flag-ki.svg"
import FlagKm from "./svg/flags/flag-km.svg"
import FlagKn from "./svg/flags/flag-kn.svg"
import FlagKp from "./svg/flags/flag-kp.svg"
import FlagKr from "./svg/flags/flag-kr.svg"
import FlagKw from "./svg/flags/flag-kw.svg"
import FlagKy from "./svg/flags/flag-ky.svg"
import FlagKz from "./svg/flags/flag-kz.svg"
import FlagLa from "./svg/flags/flag-la.svg"
import FlagLb from "./svg/flags/flag-lb.svg"
import FlagLc from "./svg/flags/flag-lc.svg"
import FlagLi from "./svg/flags/flag-li.svg"
import FlagLk from "./svg/flags/flag-lk.svg"
import FlagLr from "./svg/flags/flag-lr.svg"
import FlagLt from "./svg/flags/flag-lt.svg"
import FlagLu from "./svg/flags/flag-lu.svg"
import FlagLv from "./svg/flags/flag-lv.svg"
import FlagLy from "./svg/flags/flag-ly.svg"
import FlagMa from "./svg/flags/flag-ma.svg"
import FlagMc from "./svg/flags/flag-mc.svg"
import FlagMd from "./svg/flags/flag-md.svg"
import FlagMe from "./svg/flags/flag-me.svg"
import FlagMg from "./svg/flags/flag-mg.svg"
import FlagMh from "./svg/flags/flag-mh.svg"
import FlagMk from "./svg/flags/flag-mk.svg"
import FlagMl from "./svg/flags/flag-ml.svg"
import FlagMm from "./svg/flags/flag-mm.svg"
import FlagMn from "./svg/flags/flag-mn.svg"
import FlagMo from "./svg/flags/flag-mo.svg"
import FlagMp from "./svg/flags/flag-mp.svg"
import FlagMq from "./svg/flags/flag-mq.svg"
import FlagMr from "./svg/flags/flag-mr.svg"
import FlagMs from "./svg/flags/flag-ms.svg"
import FlagMt from "./svg/flags/flag-mt.svg"
import FlagMu from "./svg/flags/flag-mu.svg"
import FlagMv from "./svg/flags/flag-mv.svg"
import FlagMw from "./svg/flags/flag-mw.svg"
import FlagMx from "./svg/flags/flag-mx.svg"
import FlagMy from "./svg/flags/flag-my.svg"
import FlagMz from "./svg/flags/flag-mz.svg"
import FlagNa from "./svg/flags/flag-na.svg"
import FlagNf from "./svg/flags/flag-nf.svg"
import FlagNg from "./svg/flags/flag-ng.svg"
import FlagNi from "./svg/flags/flag-ni.svg"
import FlagNl from "./svg/flags/flag-nl.svg"
import FlagNo from "./svg/flags/flag-no.svg"
import FlagNp from "./svg/flags/flag-np.svg"
import FlagNr from "./svg/flags/flag-nr.svg"
import FlagNu from "./svg/flags/flag-nu.svg"
import FlagOm from "./svg/flags/flag-om.svg"
import FlagPa from "./svg/flags/flag-pa.svg"
import FlagPe from "./svg/flags/flag-pe.svg"
import FlagPf from "./svg/flags/flag-pf.svg"
import FlagPg from "./svg/flags/flag-pg.svg"
import FlagPh from "./svg/flags/flag-ph.svg"
import FlagPk from "./svg/flags/flag-pk.svg"
import FlagPl from "./svg/flags/flag-pl.svg"
import FlagPn from "./svg/flags/flag-pn.svg"
import FlagPr from "./svg/flags/flag-pr.svg"
import FlagPs from "./svg/flags/flag-ps.svg"
import FlagPt from "./svg/flags/flag-pt.svg"
import FlagPw from "./svg/flags/flag-pw.svg"
import FlagPy from "./svg/flags/flag-py.svg"
import FlagQa from "./svg/flags/flag-qa.svg"
import FlagRo from "./svg/flags/flag-ro.svg"
import FlagRs from "./svg/flags/flag-rs.svg"
import FlagRu from "./svg/flags/flag-ru.svg"
import FlagRw from "./svg/flags/flag-rw.svg"
import FlagSa from "./svg/flags/flag-sa.svg"
import FlagSb from "./svg/flags/flag-sb.svg"
import FlagSc from "./svg/flags/flag-sc.svg"
import FlagSd from "./svg/flags/flag-sd.svg"
import FlagSe from "./svg/flags/flag-se.svg"
import FlagSg from "./svg/flags/flag-sg.svg"
import FlagSi from "./svg/flags/flag-si.svg"
import FlagSk from "./svg/flags/flag-sk.svg"
import FlagSl from "./svg/flags/flag-sl.svg"
import FlagSm from "./svg/flags/flag-sm.svg"
import FlagSn from "./svg/flags/flag-sn.svg"
import FlagSo from "./svg/flags/flag-so.svg"
import FlagSr from "./svg/flags/flag-sr.svg"
import FlagSs from "./svg/flags/flag-ss.svg"
import FlagSt from "./svg/flags/flag-st.svg"
import FlagSv from "./svg/flags/flag-sv.svg"
import FlagSx from "./svg/flags/flag-sx.svg"
import FlagSy from "./svg/flags/flag-sy.svg"
import FlagSz from "./svg/flags/flag-sz.svg"
import FlagTc from "./svg/flags/flag-tc.svg"
import FlagTd from "./svg/flags/flag-td.svg"
import FlagTg from "./svg/flags/flag-tg.svg"
import FlagTh from "./svg/flags/flag-th.svg"
import FlagTj from "./svg/flags/flag-tj.svg"
import FlagTk from "./svg/flags/flag-tk.svg"
import FlagTl from "./svg/flags/flag-tl.svg"
import FlagTm from "./svg/flags/flag-tm.svg"
import FlagTn from "./svg/flags/flag-tn.svg"
import FlagTo from "./svg/flags/flag-to.svg"
import FlagTr from "./svg/flags/flag-tr.svg"
import FlagTt from "./svg/flags/flag-tt.svg"
import FlagTv from "./svg/flags/flag-tv.svg"
import FlagTw from "./svg/flags/flag-tw.svg"
import FlagTz from "./svg/flags/flag-tz.svg"
import FlagUa from "./svg/flags/flag-ua.svg"
import FlagUg from "./svg/flags/flag-ug.svg"
import FlagUk from "./svg/flags/flag-uk.svg"
import FlagUsHi from "./svg/flags/flag-us-hi.svg"
import FlagUs from "./svg/flags/flag-us.svg"
import FlagUy from "./svg/flags/flag-uy.svg"
import FlagUz from "./svg/flags/flag-uz.svg"
import FlagVa from "./svg/flags/flag-va.svg"
import FlagVc from "./svg/flags/flag-vc.svg"
import FlagVe from "./svg/flags/flag-ve.svg"
import FlagVg from "./svg/flags/flag-vg.svg"
import FlagVn from "./svg/flags/flag-vn.svg"
import FlagVu from "./svg/flags/flag-vu.svg"
import FlagWs from "./svg/flags/flag-ws.svg"
import FlagXk from "./svg/flags/flag-xk.svg"
import FlagYe from "./svg/flags/flag-ye.svg"
import FlagZa from "./svg/flags/flag-za.svg"
import FlagZm from "./svg/flags/flag-zm.svg"
import FlagZw from "./svg/flags/flag-zw.svg"
import Folder from "./svg/folder.svg"
import GatsbyLogo from "./svg/gatsby-logo.svg"
import Github from "./svg/github.svg"
import Home from "./svg/home.svg"
import HumanCell from "./svg/human-cell.svg"
import InfoIco from "./svg/info-ico.svg"
import Link from "./svg/link.svg"
import LogoAniBlack from "./svg/logo-ani-black.svg"
import LogoAniWhite from "./svg/logo-ani-white.svg"
import LogoAnimadoBlanco from "./svg/logo-animado-blanco.svg"
import LogoAnimadoNegro from "./svg/logo-animado-negro.svg"
import LogoBlack from "./svg/logo-black.svg"
import LogoWhite from "./svg/logo-white.svg"
import MagmaLogo from "./svg/magma-logo.svg"
import Magma from "./svg/magma.svg"
import MapEsAn from "./svg/maps/map-es-an.svg"
import MapEsAr from "./svg/maps/map-es-ar.svg"
import MapEsAs from "./svg/maps/map-es-as.svg"
import MapEsCb from "./svg/maps/map-es-cb.svg"
import MapEsCl from "./svg/maps/map-es-cl.svg"
import MapEsCm from "./svg/maps/map-es-cm.svg"
import MapEsCn from "./svg/maps/map-es-cn.svg"
import MapEsCt from "./svg/maps/map-es-ct.svg"
import MapEsEx from "./svg/maps/map-es-ex.svg"
import MapEsGa from "./svg/maps/map-es-ga.svg"
import MapEsIb from "./svg/maps/map-es-ib.svg"
import MapEsMc from "./svg/maps/map-es-mc.svg"
import MapEsMd from "./svg/maps/map-es-md.svg"
import MapEsNc from "./svg/maps/map-es-nc.svg"
import MapEsPv from "./svg/maps/map-es-pv.svg"
import MapEsRi from "./svg/maps/map-es-ri.svg"
import MapEsVc from "./svg/maps/map-es-vc.svg"
import MapEs from "./svg/maps/map-es.svg"
import MapEu from "./svg/maps/map-eu.svg"
import MapFr from "./svg/maps/map-fr.svg"
import MapIt from "./svg/maps/map-it.svg"
import MapNl from "./svg/maps/map-nl.svg"
import MapRu from "./svg/maps/map-ru.svg"
import MapSe from "./svg/maps/map-se.svg"
import MapUk from "./svg/maps/map-uk.svg"
import MapUs from "./svg/maps/map-us.svg"
import MedicalMeeting from "./svg/medical-meeting.svg"
import MenuClose from "./svg/menu-close.svg"
import MenuOpen from "./svg/menu-open.svg"
import NotFoundImage from "./svg/not-found-image.svg"
import NurseTalk from "./svg/nurse-talk.svg"
import NurseWithPacient from "./svg/nurse-with-pacient.svg"
import Redradix from "./svg/redradix.svg"
import RemoteIco from "./svg/remote-ico.svg"
import Repor from "./svg/repor.svg"
import Reset from "./svg/reset.svg"
import RoundAlert from "./svg/round-alert.svg"
import SecondCovidContact from "./svg/second-covid-contact.svg"
import Secuoyas from "./svg/secuoyas.svg"
import SevereCaseIcon from "./svg/severe-case-icon.svg"
import SoftCaseIcon from "./svg/soft-case-icon.svg"
import SymptonsCough from "./svg/symptons-cough.svg"
import SymptonsDiabetes from "./svg/symptons-diabetes.svg"
import SymptonsExpectoration from "./svg/symptons-expectoration.svg"
import SymptonsFever from "./svg/symptons-fever.svg"
import SymptonsHeart from "./svg/symptons-heart.svg"
import SymptonsHospital from "./svg/symptons-hospital.svg"
import SymptonsHypertension from "./svg/symptons-hypertension.svg"
import SymptonsQuarantine from "./svg/symptons-quarantine.svg"
import SymptonsUnwell from "./svg/symptons-unwell.svg"
import SymtonsCough from "./svg/symtons-cough.svg"
import ThirdCovidContact from "./svg/third-covid-contact.svg"
import Vector from "./svg/vector.svg"
import VirusCough from "./svg/virus-cough.svg"
import VirusFever from "./svg/virus-fever.svg"
import VirusGreenIco from "./svg/virus-green-ico.svg"
import VirusIco from "./svg/virus-ico.svg"
import VirusIncubation from "./svg/virus-incubation.svg"
import VirusInfected3079 from "./svg/virus-infected-30-79.svg"
import VirusInfectedMen from "./svg/virus-infected-men.svg"
import VirusInfectedUnder20 from "./svg/virus-infected-under-20.svg"
import VirusInfected from "./svg/virus-infected.svg"
import VirusLungDamage from "./svg/virus-lung-damage.svg"
import VirusSoreThroath from "./svg/virus-sore-throath.svg"
import VirusSymptoms from "./svg/virus-symptoms.svg"
import VirusWhiteIco from "./svg/virus-white-ico.svg"
import Zoom from "./svg/zoom.svg"
import Zoomin from "./svg/zoomin.svg"
import Zoomout from "./svg/zoomout.svg"

const Base = css`
  ${space}
  ${color}
  ${layout}
  * {
    ${system({
      fill: {
        property: "fill",
        scale: "color",
      },
    })}
  }
`


const BaseAccessApi = styled(AccessApi)`${Base}`
const BaseAlert = styled(Alert)`${Base}`
const BaseApi = styled(Api)`${Base}`
const BaseArrowBottom = styled(ArrowBottom)`${Base}`
const BaseArrowLeft = styled(ArrowLeft)`${Base}`
const BaseArrowRight = styled(ArrowRight)`${Base}`
const BaseArrowTop = styled(ArrowTop)`${Base}`
const BaseArrow = styled(Arrow)`${Base}`
const BaseBitbucket = styled(Bitbucket)`${Base}`
const BaseBook = styled(Book)`${Base}`
const BaseCalendar = styled(Calendar)`${Base}`
const BaseChart = styled(Chart)`${Base}`
const BaseCleanProducts = styled(CleanProducts)`${Base}`
const BaseClockBlack = styled(ClockBlack)`${Base}`
const BaseClock = styled(Clock)`${Base}`
const BaseContentIndex = styled(ContentIndex)`${Base}`
const BaseArn = styled(Arn)`${Base}`
const BaseEProtein = styled(EProtein)`${Base}`
const BaseGlycoproteicMembrane = styled(GlycoproteicMembrane)`${Base}`
const BaseNProtein = styled(NProtein)`${Base}`
const BaseSProtein = styled(SProtein)`${Base}`
const BaseCoronavirusIlu = styled(CoronavirusIlu)`${Base}`
const BaseDashboard = styled(Dashboard)`${Base}`
const BaseDataIco = styled(DataIco)`${Base}`
const BaseDistancedCat = styled(DistancedCat)`${Base}`
const BaseDistancedMan = styled(DistancedMan)`${Base}`
const BaseDistancedWoman = styled(DistancedWoman)`${Base}`
const BaseDownload = styled(Download)`${Base}`
const BaseDrag = styled(Drag)`${Base}`
const BaseFile = styled(File)`${Base}`
const BaseFirstCovidContact = styled(FirstCovidContact)`${Base}`
const BaseFlagOms = styled(FlagOms)`${Base}`
const BaseFlagAd = styled(FlagAd)`${Base}`
const BaseFlagAe = styled(FlagAe)`${Base}`
const BaseFlagAf = styled(FlagAf)`${Base}`
const BaseFlagAg = styled(FlagAg)`${Base}`
const BaseFlagAi = styled(FlagAi)`${Base}`
const BaseFlagAl = styled(FlagAl)`${Base}`
const BaseFlagAm = styled(FlagAm)`${Base}`
const BaseFlagAo = styled(FlagAo)`${Base}`
const BaseFlagAr = styled(FlagAr)`${Base}`
const BaseFlagAs = styled(FlagAs)`${Base}`
const BaseFlagAt = styled(FlagAt)`${Base}`
const BaseFlagAu = styled(FlagAu)`${Base}`
const BaseFlagAw = styled(FlagAw)`${Base}`
const BaseFlagAx = styled(FlagAx)`${Base}`
const BaseFlagAz = styled(FlagAz)`${Base}`
const BaseFlagBa = styled(FlagBa)`${Base}`
const BaseFlagBb = styled(FlagBb)`${Base}`
const BaseFlagBd = styled(FlagBd)`${Base}`
const BaseFlagBe = styled(FlagBe)`${Base}`
const BaseFlagBf = styled(FlagBf)`${Base}`
const BaseFlagBg = styled(FlagBg)`${Base}`
const BaseFlagBh = styled(FlagBh)`${Base}`
const BaseFlagBi = styled(FlagBi)`${Base}`
const BaseFlagBj = styled(FlagBj)`${Base}`
const BaseFlagBm = styled(FlagBm)`${Base}`
const BaseFlagBn = styled(FlagBn)`${Base}`
const BaseFlagBo = styled(FlagBo)`${Base}`
const BaseFlagBq = styled(FlagBq)`${Base}`
const BaseFlagBr = styled(FlagBr)`${Base}`
const BaseFlagBs = styled(FlagBs)`${Base}`
const BaseFlagBt = styled(FlagBt)`${Base}`
const BaseFlagBw = styled(FlagBw)`${Base}`
const BaseFlagBy = styled(FlagBy)`${Base}`
const BaseFlagBz = styled(FlagBz)`${Base}`
const BaseFlagCa = styled(FlagCa)`${Base}`
const BaseFlagCc = styled(FlagCc)`${Base}`
const BaseFlagCd = styled(FlagCd)`${Base}`
const BaseFlagCf = styled(FlagCf)`${Base}`
const BaseFlagCg = styled(FlagCg)`${Base}`
const BaseFlagCh = styled(FlagCh)`${Base}`
const BaseFlagCi = styled(FlagCi)`${Base}`
const BaseFlagCk = styled(FlagCk)`${Base}`
const BaseFlagCl = styled(FlagCl)`${Base}`
const BaseFlagCm = styled(FlagCm)`${Base}`
const BaseFlagCn = styled(FlagCn)`${Base}`
const BaseFlagCo = styled(FlagCo)`${Base}`
const BaseFlagCr = styled(FlagCr)`${Base}`
const BaseFlagCu = styled(FlagCu)`${Base}`
const BaseFlagCv = styled(FlagCv)`${Base}`
const BaseFlagCw = styled(FlagCw)`${Base}`
const BaseFlagCx = styled(FlagCx)`${Base}`
const BaseFlagCz = styled(FlagCz)`${Base}`
const BaseFlagDe = styled(FlagDe)`${Base}`
const BaseFlagDj = styled(FlagDj)`${Base}`
const BaseFlagDk = styled(FlagDk)`${Base}`
const BaseFlagDm = styled(FlagDm)`${Base}`
const BaseFlagDo = styled(FlagDo)`${Base}`
const BaseFlagDz = styled(FlagDz)`${Base}`
const BaseFlagEcW = styled(FlagEcW)`${Base}`
const BaseFlagEc = styled(FlagEc)`${Base}`
const BaseFlagEe = styled(FlagEe)`${Base}`
const BaseFlagEg = styled(FlagEg)`${Base}`
const BaseFlagEh = styled(FlagEh)`${Base}`
const BaseFlagEr = styled(FlagEr)`${Base}`
const BaseFlagEsAn = styled(FlagEsAn)`${Base}`
const BaseFlagEsAr = styled(FlagEsAr)`${Base}`
const BaseFlagEsAs = styled(FlagEsAs)`${Base}`
const BaseFlagEsCb = styled(FlagEsCb)`${Base}`
const BaseFlagEsCe = styled(FlagEsCe)`${Base}`
const BaseFlagEsCl = styled(FlagEsCl)`${Base}`
const BaseFlagEsCm = styled(FlagEsCm)`${Base}`
const BaseFlagEsCn = styled(FlagEsCn)`${Base}`
const BaseFlagEsCt = styled(FlagEsCt)`${Base}`
const BaseFlagEsEx = styled(FlagEsEx)`${Base}`
const BaseFlagEsGa = styled(FlagEsGa)`${Base}`
const BaseFlagEsIb = styled(FlagEsIb)`${Base}`
const BaseFlagEsMc = styled(FlagEsMc)`${Base}`
const BaseFlagEsMd = styled(FlagEsMd)`${Base}`
const BaseFlagEsMl = styled(FlagEsMl)`${Base}`
const BaseFlagEsNc = styled(FlagEsNc)`${Base}`
const BaseFlagEsPv = styled(FlagEsPv)`${Base}`
const BaseFlagEsRi = styled(FlagEsRi)`${Base}`
const BaseFlagEsVc = styled(FlagEsVc)`${Base}`
const BaseFlagEs = styled(FlagEs)`${Base}`
const BaseFlagEt = styled(FlagEt)`${Base}`
const BaseFlagEu = styled(FlagEu)`${Base}`
const BaseFlagFi = styled(FlagFi)`${Base}`
const BaseFlagFj = styled(FlagFj)`${Base}`
const BaseFlagFk = styled(FlagFk)`${Base}`
const BaseFlagFm = styled(FlagFm)`${Base}`
const BaseFlagFr = styled(FlagFr)`${Base}`
const BaseFlagGa = styled(FlagGa)`${Base}`
const BaseFlagGb = styled(FlagGb)`${Base}`
const BaseFlagGd = styled(FlagGd)`${Base}`
const BaseFlagGe = styled(FlagGe)`${Base}`
const BaseFlagGg = styled(FlagGg)`${Base}`
const BaseFlagGh = styled(FlagGh)`${Base}`
const BaseFlagGi = styled(FlagGi)`${Base}`
const BaseFlagGl = styled(FlagGl)`${Base}`
const BaseFlagGm = styled(FlagGm)`${Base}`
const BaseFlagGn = styled(FlagGn)`${Base}`
const BaseFlagGq = styled(FlagGq)`${Base}`
const BaseFlagGr = styled(FlagGr)`${Base}`
const BaseFlagGt = styled(FlagGt)`${Base}`
const BaseFlagGu = styled(FlagGu)`${Base}`
const BaseFlagGw = styled(FlagGw)`${Base}`
const BaseFlagHk = styled(FlagHk)`${Base}`
const BaseFlagHn = styled(FlagHn)`${Base}`
const BaseFlagHr = styled(FlagHr)`${Base}`
const BaseFlagHt = styled(FlagHt)`${Base}`
const BaseFlagHu = styled(FlagHu)`${Base}`
const BaseFlagId = styled(FlagId)`${Base}`
const BaseFlagIe = styled(FlagIe)`${Base}`
const BaseFlagIl = styled(FlagIl)`${Base}`
const BaseFlagIm = styled(FlagIm)`${Base}`
const BaseFlagIn = styled(FlagIn)`${Base}`
const BaseFlagIo = styled(FlagIo)`${Base}`
const BaseFlagIq = styled(FlagIq)`${Base}`
const BaseFlagIr = styled(FlagIr)`${Base}`
const BaseFlagIs = styled(FlagIs)`${Base}`
const BaseFlagIt = styled(FlagIt)`${Base}`
const BaseFlagJe = styled(FlagJe)`${Base}`
const BaseFlagJm = styled(FlagJm)`${Base}`
const BaseFlagJo = styled(FlagJo)`${Base}`
const BaseFlagJp = styled(FlagJp)`${Base}`
const BaseFlagKe = styled(FlagKe)`${Base}`
const BaseFlagKg = styled(FlagKg)`${Base}`
const BaseFlagKh = styled(FlagKh)`${Base}`
const BaseFlagKi = styled(FlagKi)`${Base}`
const BaseFlagKm = styled(FlagKm)`${Base}`
const BaseFlagKn = styled(FlagKn)`${Base}`
const BaseFlagKp = styled(FlagKp)`${Base}`
const BaseFlagKr = styled(FlagKr)`${Base}`
const BaseFlagKw = styled(FlagKw)`${Base}`
const BaseFlagKy = styled(FlagKy)`${Base}`
const BaseFlagKz = styled(FlagKz)`${Base}`
const BaseFlagLa = styled(FlagLa)`${Base}`
const BaseFlagLb = styled(FlagLb)`${Base}`
const BaseFlagLc = styled(FlagLc)`${Base}`
const BaseFlagLi = styled(FlagLi)`${Base}`
const BaseFlagLk = styled(FlagLk)`${Base}`
const BaseFlagLr = styled(FlagLr)`${Base}`
const BaseFlagLt = styled(FlagLt)`${Base}`
const BaseFlagLu = styled(FlagLu)`${Base}`
const BaseFlagLv = styled(FlagLv)`${Base}`
const BaseFlagLy = styled(FlagLy)`${Base}`
const BaseFlagMa = styled(FlagMa)`${Base}`
const BaseFlagMc = styled(FlagMc)`${Base}`
const BaseFlagMd = styled(FlagMd)`${Base}`
const BaseFlagMe = styled(FlagMe)`${Base}`
const BaseFlagMg = styled(FlagMg)`${Base}`
const BaseFlagMh = styled(FlagMh)`${Base}`
const BaseFlagMk = styled(FlagMk)`${Base}`
const BaseFlagMl = styled(FlagMl)`${Base}`
const BaseFlagMm = styled(FlagMm)`${Base}`
const BaseFlagMn = styled(FlagMn)`${Base}`
const BaseFlagMo = styled(FlagMo)`${Base}`
const BaseFlagMp = styled(FlagMp)`${Base}`
const BaseFlagMq = styled(FlagMq)`${Base}`
const BaseFlagMr = styled(FlagMr)`${Base}`
const BaseFlagMs = styled(FlagMs)`${Base}`
const BaseFlagMt = styled(FlagMt)`${Base}`
const BaseFlagMu = styled(FlagMu)`${Base}`
const BaseFlagMv = styled(FlagMv)`${Base}`
const BaseFlagMw = styled(FlagMw)`${Base}`
const BaseFlagMx = styled(FlagMx)`${Base}`
const BaseFlagMy = styled(FlagMy)`${Base}`
const BaseFlagMz = styled(FlagMz)`${Base}`
const BaseFlagNa = styled(FlagNa)`${Base}`
const BaseFlagNf = styled(FlagNf)`${Base}`
const BaseFlagNg = styled(FlagNg)`${Base}`
const BaseFlagNi = styled(FlagNi)`${Base}`
const BaseFlagNl = styled(FlagNl)`${Base}`
const BaseFlagNo = styled(FlagNo)`${Base}`
const BaseFlagNp = styled(FlagNp)`${Base}`
const BaseFlagNr = styled(FlagNr)`${Base}`
const BaseFlagNu = styled(FlagNu)`${Base}`
const BaseFlagOm = styled(FlagOm)`${Base}`
const BaseFlagPa = styled(FlagPa)`${Base}`
const BaseFlagPe = styled(FlagPe)`${Base}`
const BaseFlagPf = styled(FlagPf)`${Base}`
const BaseFlagPg = styled(FlagPg)`${Base}`
const BaseFlagPh = styled(FlagPh)`${Base}`
const BaseFlagPk = styled(FlagPk)`${Base}`
const BaseFlagPl = styled(FlagPl)`${Base}`
const BaseFlagPn = styled(FlagPn)`${Base}`
const BaseFlagPr = styled(FlagPr)`${Base}`
const BaseFlagPs = styled(FlagPs)`${Base}`
const BaseFlagPt = styled(FlagPt)`${Base}`
const BaseFlagPw = styled(FlagPw)`${Base}`
const BaseFlagPy = styled(FlagPy)`${Base}`
const BaseFlagQa = styled(FlagQa)`${Base}`
const BaseFlagRo = styled(FlagRo)`${Base}`
const BaseFlagRs = styled(FlagRs)`${Base}`
const BaseFlagRu = styled(FlagRu)`${Base}`
const BaseFlagRw = styled(FlagRw)`${Base}`
const BaseFlagSa = styled(FlagSa)`${Base}`
const BaseFlagSb = styled(FlagSb)`${Base}`
const BaseFlagSc = styled(FlagSc)`${Base}`
const BaseFlagSd = styled(FlagSd)`${Base}`
const BaseFlagSe = styled(FlagSe)`${Base}`
const BaseFlagSg = styled(FlagSg)`${Base}`
const BaseFlagSi = styled(FlagSi)`${Base}`
const BaseFlagSk = styled(FlagSk)`${Base}`
const BaseFlagSl = styled(FlagSl)`${Base}`
const BaseFlagSm = styled(FlagSm)`${Base}`
const BaseFlagSn = styled(FlagSn)`${Base}`
const BaseFlagSo = styled(FlagSo)`${Base}`
const BaseFlagSr = styled(FlagSr)`${Base}`
const BaseFlagSs = styled(FlagSs)`${Base}`
const BaseFlagSt = styled(FlagSt)`${Base}`
const BaseFlagSv = styled(FlagSv)`${Base}`
const BaseFlagSx = styled(FlagSx)`${Base}`
const BaseFlagSy = styled(FlagSy)`${Base}`
const BaseFlagSz = styled(FlagSz)`${Base}`
const BaseFlagTc = styled(FlagTc)`${Base}`
const BaseFlagTd = styled(FlagTd)`${Base}`
const BaseFlagTg = styled(FlagTg)`${Base}`
const BaseFlagTh = styled(FlagTh)`${Base}`
const BaseFlagTj = styled(FlagTj)`${Base}`
const BaseFlagTk = styled(FlagTk)`${Base}`
const BaseFlagTl = styled(FlagTl)`${Base}`
const BaseFlagTm = styled(FlagTm)`${Base}`
const BaseFlagTn = styled(FlagTn)`${Base}`
const BaseFlagTo = styled(FlagTo)`${Base}`
const BaseFlagTr = styled(FlagTr)`${Base}`
const BaseFlagTt = styled(FlagTt)`${Base}`
const BaseFlagTv = styled(FlagTv)`${Base}`
const BaseFlagTw = styled(FlagTw)`${Base}`
const BaseFlagTz = styled(FlagTz)`${Base}`
const BaseFlagUa = styled(FlagUa)`${Base}`
const BaseFlagUg = styled(FlagUg)`${Base}`
const BaseFlagUk = styled(FlagUk)`${Base}`
const BaseFlagUsHi = styled(FlagUsHi)`${Base}`
const BaseFlagUs = styled(FlagUs)`${Base}`
const BaseFlagUy = styled(FlagUy)`${Base}`
const BaseFlagUz = styled(FlagUz)`${Base}`
const BaseFlagVa = styled(FlagVa)`${Base}`
const BaseFlagVc = styled(FlagVc)`${Base}`
const BaseFlagVe = styled(FlagVe)`${Base}`
const BaseFlagVg = styled(FlagVg)`${Base}`
const BaseFlagVn = styled(FlagVn)`${Base}`
const BaseFlagVu = styled(FlagVu)`${Base}`
const BaseFlagWs = styled(FlagWs)`${Base}`
const BaseFlagXk = styled(FlagXk)`${Base}`
const BaseFlagYe = styled(FlagYe)`${Base}`
const BaseFlagZa = styled(FlagZa)`${Base}`
const BaseFlagZm = styled(FlagZm)`${Base}`
const BaseFlagZw = styled(FlagZw)`${Base}`
const BaseFolder = styled(Folder)`${Base}`
const BaseGatsbyLogo = styled(GatsbyLogo)`${Base}`
const BaseGithub = styled(Github)`${Base}`
const BaseHome = styled(Home)`${Base}`
const BaseHumanCell = styled(HumanCell)`${Base}`
const BaseInfoIco = styled(InfoIco)`${Base}`
const BaseLink = styled(Link)`${Base}`
const BaseLogoAniBlack = styled(LogoAniBlack)`${Base}`
const BaseLogoAniWhite = styled(LogoAniWhite)`${Base}`
const BaseLogoAnimadoBlanco = styled(LogoAnimadoBlanco)`${Base}`
const BaseLogoAnimadoNegro = styled(LogoAnimadoNegro)`${Base}`
const BaseLogoBlack = styled(LogoBlack)`${Base}`
const BaseLogoWhite = styled(LogoWhite)`${Base}`
const BaseMagmaLogo = styled(MagmaLogo)`${Base}`
const BaseMagma = styled(Magma)`${Base}`
const BaseMapEsAn = styled(MapEsAn)`${Base}`
const BaseMapEsAr = styled(MapEsAr)`${Base}`
const BaseMapEsAs = styled(MapEsAs)`${Base}`
const BaseMapEsCb = styled(MapEsCb)`${Base}`
const BaseMapEsCl = styled(MapEsCl)`${Base}`
const BaseMapEsCm = styled(MapEsCm)`${Base}`
const BaseMapEsCn = styled(MapEsCn)`${Base}`
const BaseMapEsCt = styled(MapEsCt)`${Base}`
const BaseMapEsEx = styled(MapEsEx)`${Base}`
const BaseMapEsGa = styled(MapEsGa)`${Base}`
const BaseMapEsIb = styled(MapEsIb)`${Base}`
const BaseMapEsMc = styled(MapEsMc)`${Base}`
const BaseMapEsMd = styled(MapEsMd)`${Base}`
const BaseMapEsNc = styled(MapEsNc)`${Base}`
const BaseMapEsPv = styled(MapEsPv)`${Base}`
const BaseMapEsRi = styled(MapEsRi)`${Base}`
const BaseMapEsVc = styled(MapEsVc)`${Base}`
const BaseMapEs = styled(MapEs)`${Base}`
const BaseMapEu = styled(MapEu)`${Base}`
const BaseMapFr = styled(MapFr)`${Base}`
const BaseMapIt = styled(MapIt)`${Base}`
const BaseMapNl = styled(MapNl)`${Base}`
const BaseMapRu = styled(MapRu)`${Base}`
const BaseMapSe = styled(MapSe)`${Base}`
const BaseMapUk = styled(MapUk)`${Base}`
const BaseMapUs = styled(MapUs)`${Base}`
const BaseMedicalMeeting = styled(MedicalMeeting)`${Base}`
const BaseMenuClose = styled(MenuClose)`${Base}`
const BaseMenuOpen = styled(MenuOpen)`${Base}`
const BaseNotFoundImage = styled(NotFoundImage)`${Base}`
const BaseNurseTalk = styled(NurseTalk)`${Base}`
const BaseNurseWithPacient = styled(NurseWithPacient)`${Base}`
const BaseRedradix = styled(Redradix)`${Base}`
const BaseRemoteIco = styled(RemoteIco)`${Base}`
const BaseRepor = styled(Repor)`${Base}`
const BaseReset = styled(Reset)`${Base}`
const BaseRoundAlert = styled(RoundAlert)`${Base}`
const BaseSecondCovidContact = styled(SecondCovidContact)`${Base}`
const BaseSecuoyas = styled(Secuoyas)`${Base}`
const BaseSevereCaseIcon = styled(SevereCaseIcon)`${Base}`
const BaseSoftCaseIcon = styled(SoftCaseIcon)`${Base}`
const BaseSymptonsCough = styled(SymptonsCough)`${Base}`
const BaseSymptonsDiabetes = styled(SymptonsDiabetes)`${Base}`
const BaseSymptonsExpectoration = styled(SymptonsExpectoration)`${Base}`
const BaseSymptonsFever = styled(SymptonsFever)`${Base}`
const BaseSymptonsHeart = styled(SymptonsHeart)`${Base}`
const BaseSymptonsHospital = styled(SymptonsHospital)`${Base}`
const BaseSymptonsHypertension = styled(SymptonsHypertension)`${Base}`
const BaseSymptonsQuarantine = styled(SymptonsQuarantine)`${Base}`
const BaseSymptonsUnwell = styled(SymptonsUnwell)`${Base}`
const BaseSymtonsCough = styled(SymtonsCough)`${Base}`
const BaseThirdCovidContact = styled(ThirdCovidContact)`${Base}`
const BaseVector = styled(Vector)`${Base}`
const BaseVirusCough = styled(VirusCough)`${Base}`
const BaseVirusFever = styled(VirusFever)`${Base}`
const BaseVirusGreenIco = styled(VirusGreenIco)`${Base}`
const BaseVirusIco = styled(VirusIco)`${Base}`
const BaseVirusIncubation = styled(VirusIncubation)`${Base}`
const BaseVirusInfected3079 = styled(VirusInfected3079)`${Base}`
const BaseVirusInfectedMen = styled(VirusInfectedMen)`${Base}`
const BaseVirusInfectedUnder20 = styled(VirusInfectedUnder20)`${Base}`
const BaseVirusInfected = styled(VirusInfected)`${Base}`
const BaseVirusLungDamage = styled(VirusLungDamage)`${Base}`
const BaseVirusSoreThroath = styled(VirusSoreThroath)`${Base}`
const BaseVirusSymptoms = styled(VirusSymptoms)`${Base}`
const BaseVirusWhiteIco = styled(VirusWhiteIco)`${Base}`
const BaseZoom = styled(Zoom)`${Base}`
const BaseZoomin = styled(Zoomin)`${Base}`
const BaseZoomout = styled(Zoomout)`${Base}`

const StyledAccessApi = ({...props}) => {
      return <BaseAccessApi {...props} />
    }
const StyledAlert = ({...props}) => {
      return <BaseAlert {...props} />
    }
const StyledApi = ({...props}) => {
      return <BaseApi {...props} />
    }
const StyledArrowBottom = ({...props}) => {
      return <BaseArrowBottom {...props} />
    }
const StyledArrowLeft = ({...props}) => {
      return <BaseArrowLeft {...props} />
    }
const StyledArrowRight = ({...props}) => {
      return <BaseArrowRight {...props} />
    }
const StyledArrowTop = ({...props}) => {
      return <BaseArrowTop {...props} />
    }
const StyledArrow = ({...props}) => {
      return <BaseArrow {...props} />
    }
const StyledBitbucket = ({...props}) => {
      return <BaseBitbucket {...props} />
    }
const StyledBook = ({...props}) => {
      return <BaseBook {...props} />
    }
const StyledCalendar = ({...props}) => {
      return <BaseCalendar {...props} />
    }
const StyledChart = ({...props}) => {
      return <BaseChart {...props} />
    }
const StyledCleanProducts = ({...props}) => {
      return <BaseCleanProducts {...props} />
    }
const StyledClockBlack = ({...props}) => {
      return <BaseClockBlack {...props} />
    }
const StyledClock = ({...props}) => {
      return <BaseClock {...props} />
    }
const StyledContentIndex = ({...props}) => {
      return <BaseContentIndex {...props} />
    }
const StyledArn = ({...props}) => {
      return <BaseArn {...props} />
    }
const StyledEProtein = ({...props}) => {
      return <BaseEProtein {...props} />
    }
const StyledGlycoproteicMembrane = ({...props}) => {
      return <BaseGlycoproteicMembrane {...props} />
    }
const StyledNProtein = ({...props}) => {
      return <BaseNProtein {...props} />
    }
const StyledSProtein = ({...props}) => {
      return <BaseSProtein {...props} />
    }
const StyledCoronavirusIlu = ({...props}) => {
      return <BaseCoronavirusIlu {...props} />
    }
const StyledDashboard = ({...props}) => {
      return <BaseDashboard {...props} />
    }
const StyledDataIco = ({...props}) => {
      return <BaseDataIco {...props} />
    }
const StyledDistancedCat = ({...props}) => {
      return <BaseDistancedCat {...props} />
    }
const StyledDistancedMan = ({...props}) => {
      return <BaseDistancedMan {...props} />
    }
const StyledDistancedWoman = ({...props}) => {
      return <BaseDistancedWoman {...props} />
    }
const StyledDownload = ({...props}) => {
      return <BaseDownload {...props} />
    }
const StyledDrag = ({...props}) => {
      return <BaseDrag {...props} />
    }
const StyledFile = ({...props}) => {
      return <BaseFile {...props} />
    }
const StyledFirstCovidContact = ({...props}) => {
      return <BaseFirstCovidContact {...props} />
    }
const StyledFlagOms = ({...props}) => {
      return <BaseFlagOms {...props} />
    }
const StyledFlagAd = ({...props}) => {
      return <BaseFlagAd {...props} />
    }
const StyledFlagAe = ({...props}) => {
      return <BaseFlagAe {...props} />
    }
const StyledFlagAf = ({...props}) => {
      return <BaseFlagAf {...props} />
    }
const StyledFlagAg = ({...props}) => {
      return <BaseFlagAg {...props} />
    }
const StyledFlagAi = ({...props}) => {
      return <BaseFlagAi {...props} />
    }
const StyledFlagAl = ({...props}) => {
      return <BaseFlagAl {...props} />
    }
const StyledFlagAm = ({...props}) => {
      return <BaseFlagAm {...props} />
    }
const StyledFlagAo = ({...props}) => {
      return <BaseFlagAo {...props} />
    }
const StyledFlagAr = ({...props}) => {
      return <BaseFlagAr {...props} />
    }
const StyledFlagAs = ({...props}) => {
      return <BaseFlagAs {...props} />
    }
const StyledFlagAt = ({...props}) => {
      return <BaseFlagAt {...props} />
    }
const StyledFlagAu = ({...props}) => {
      return <BaseFlagAu {...props} />
    }
const StyledFlagAw = ({...props}) => {
      return <BaseFlagAw {...props} />
    }
const StyledFlagAx = ({...props}) => {
      return <BaseFlagAx {...props} />
    }
const StyledFlagAz = ({...props}) => {
      return <BaseFlagAz {...props} />
    }
const StyledFlagBa = ({...props}) => {
      return <BaseFlagBa {...props} />
    }
const StyledFlagBb = ({...props}) => {
      return <BaseFlagBb {...props} />
    }
const StyledFlagBd = ({...props}) => {
      return <BaseFlagBd {...props} />
    }
const StyledFlagBe = ({...props}) => {
      return <BaseFlagBe {...props} />
    }
const StyledFlagBf = ({...props}) => {
      return <BaseFlagBf {...props} />
    }
const StyledFlagBg = ({...props}) => {
      return <BaseFlagBg {...props} />
    }
const StyledFlagBh = ({...props}) => {
      return <BaseFlagBh {...props} />
    }
const StyledFlagBi = ({...props}) => {
      return <BaseFlagBi {...props} />
    }
const StyledFlagBj = ({...props}) => {
      return <BaseFlagBj {...props} />
    }
const StyledFlagBm = ({...props}) => {
      return <BaseFlagBm {...props} />
    }
const StyledFlagBn = ({...props}) => {
      return <BaseFlagBn {...props} />
    }
const StyledFlagBo = ({...props}) => {
      return <BaseFlagBo {...props} />
    }
const StyledFlagBq = ({...props}) => {
      return <BaseFlagBq {...props} />
    }
const StyledFlagBr = ({...props}) => {
      return <BaseFlagBr {...props} />
    }
const StyledFlagBs = ({...props}) => {
      return <BaseFlagBs {...props} />
    }
const StyledFlagBt = ({...props}) => {
      return <BaseFlagBt {...props} />
    }
const StyledFlagBw = ({...props}) => {
      return <BaseFlagBw {...props} />
    }
const StyledFlagBy = ({...props}) => {
      return <BaseFlagBy {...props} />
    }
const StyledFlagBz = ({...props}) => {
      return <BaseFlagBz {...props} />
    }
const StyledFlagCa = ({...props}) => {
      return <BaseFlagCa {...props} />
    }
const StyledFlagCc = ({...props}) => {
      return <BaseFlagCc {...props} />
    }
const StyledFlagCd = ({...props}) => {
      return <BaseFlagCd {...props} />
    }
const StyledFlagCf = ({...props}) => {
      return <BaseFlagCf {...props} />
    }
const StyledFlagCg = ({...props}) => {
      return <BaseFlagCg {...props} />
    }
const StyledFlagCh = ({...props}) => {
      return <BaseFlagCh {...props} />
    }
const StyledFlagCi = ({...props}) => {
      return <BaseFlagCi {...props} />
    }
const StyledFlagCk = ({...props}) => {
      return <BaseFlagCk {...props} />
    }
const StyledFlagCl = ({...props}) => {
      return <BaseFlagCl {...props} />
    }
const StyledFlagCm = ({...props}) => {
      return <BaseFlagCm {...props} />
    }
const StyledFlagCn = ({...props}) => {
      return <BaseFlagCn {...props} />
    }
const StyledFlagCo = ({...props}) => {
      return <BaseFlagCo {...props} />
    }
const StyledFlagCr = ({...props}) => {
      return <BaseFlagCr {...props} />
    }
const StyledFlagCu = ({...props}) => {
      return <BaseFlagCu {...props} />
    }
const StyledFlagCv = ({...props}) => {
      return <BaseFlagCv {...props} />
    }
const StyledFlagCw = ({...props}) => {
      return <BaseFlagCw {...props} />
    }
const StyledFlagCx = ({...props}) => {
      return <BaseFlagCx {...props} />
    }
const StyledFlagCz = ({...props}) => {
      return <BaseFlagCz {...props} />
    }
const StyledFlagDe = ({...props}) => {
      return <BaseFlagDe {...props} />
    }
const StyledFlagDj = ({...props}) => {
      return <BaseFlagDj {...props} />
    }
const StyledFlagDk = ({...props}) => {
      return <BaseFlagDk {...props} />
    }
const StyledFlagDm = ({...props}) => {
      return <BaseFlagDm {...props} />
    }
const StyledFlagDo = ({...props}) => {
      return <BaseFlagDo {...props} />
    }
const StyledFlagDz = ({...props}) => {
      return <BaseFlagDz {...props} />
    }
const StyledFlagEcW = ({...props}) => {
      return <BaseFlagEcW {...props} />
    }
const StyledFlagEc = ({...props}) => {
      return <BaseFlagEc {...props} />
    }
const StyledFlagEe = ({...props}) => {
      return <BaseFlagEe {...props} />
    }
const StyledFlagEg = ({...props}) => {
      return <BaseFlagEg {...props} />
    }
const StyledFlagEh = ({...props}) => {
      return <BaseFlagEh {...props} />
    }
const StyledFlagEr = ({...props}) => {
      return <BaseFlagEr {...props} />
    }
const StyledFlagEsAn = ({...props}) => {
      return <BaseFlagEsAn {...props} />
    }
const StyledFlagEsAr = ({...props}) => {
      return <BaseFlagEsAr {...props} />
    }
const StyledFlagEsAs = ({...props}) => {
      return <BaseFlagEsAs {...props} />
    }
const StyledFlagEsCb = ({...props}) => {
      return <BaseFlagEsCb {...props} />
    }
const StyledFlagEsCe = ({...props}) => {
      return <BaseFlagEsCe {...props} />
    }
const StyledFlagEsCl = ({...props}) => {
      return <BaseFlagEsCl {...props} />
    }
const StyledFlagEsCm = ({...props}) => {
      return <BaseFlagEsCm {...props} />
    }
const StyledFlagEsCn = ({...props}) => {
      return <BaseFlagEsCn {...props} />
    }
const StyledFlagEsCt = ({...props}) => {
      return <BaseFlagEsCt {...props} />
    }
const StyledFlagEsEx = ({...props}) => {
      return <BaseFlagEsEx {...props} />
    }
const StyledFlagEsGa = ({...props}) => {
      return <BaseFlagEsGa {...props} />
    }
const StyledFlagEsIb = ({...props}) => {
      return <BaseFlagEsIb {...props} />
    }
const StyledFlagEsMc = ({...props}) => {
      return <BaseFlagEsMc {...props} />
    }
const StyledFlagEsMd = ({...props}) => {
      return <BaseFlagEsMd {...props} />
    }
const StyledFlagEsMl = ({...props}) => {
      return <BaseFlagEsMl {...props} />
    }
const StyledFlagEsNc = ({...props}) => {
      return <BaseFlagEsNc {...props} />
    }
const StyledFlagEsPv = ({...props}) => {
      return <BaseFlagEsPv {...props} />
    }
const StyledFlagEsRi = ({...props}) => {
      return <BaseFlagEsRi {...props} />
    }
const StyledFlagEsVc = ({...props}) => {
      return <BaseFlagEsVc {...props} />
    }
const StyledFlagEs = ({...props}) => {
      return <BaseFlagEs {...props} />
    }
const StyledFlagEt = ({...props}) => {
      return <BaseFlagEt {...props} />
    }
const StyledFlagEu = ({...props}) => {
      return <BaseFlagEu {...props} />
    }
const StyledFlagFi = ({...props}) => {
      return <BaseFlagFi {...props} />
    }
const StyledFlagFj = ({...props}) => {
      return <BaseFlagFj {...props} />
    }
const StyledFlagFk = ({...props}) => {
      return <BaseFlagFk {...props} />
    }
const StyledFlagFm = ({...props}) => {
      return <BaseFlagFm {...props} />
    }
const StyledFlagFr = ({...props}) => {
      return <BaseFlagFr {...props} />
    }
const StyledFlagGa = ({...props}) => {
      return <BaseFlagGa {...props} />
    }
const StyledFlagGb = ({...props}) => {
      return <BaseFlagGb {...props} />
    }
const StyledFlagGd = ({...props}) => {
      return <BaseFlagGd {...props} />
    }
const StyledFlagGe = ({...props}) => {
      return <BaseFlagGe {...props} />
    }
const StyledFlagGg = ({...props}) => {
      return <BaseFlagGg {...props} />
    }
const StyledFlagGh = ({...props}) => {
      return <BaseFlagGh {...props} />
    }
const StyledFlagGi = ({...props}) => {
      return <BaseFlagGi {...props} />
    }
const StyledFlagGl = ({...props}) => {
      return <BaseFlagGl {...props} />
    }
const StyledFlagGm = ({...props}) => {
      return <BaseFlagGm {...props} />
    }
const StyledFlagGn = ({...props}) => {
      return <BaseFlagGn {...props} />
    }
const StyledFlagGq = ({...props}) => {
      return <BaseFlagGq {...props} />
    }
const StyledFlagGr = ({...props}) => {
      return <BaseFlagGr {...props} />
    }
const StyledFlagGt = ({...props}) => {
      return <BaseFlagGt {...props} />
    }
const StyledFlagGu = ({...props}) => {
      return <BaseFlagGu {...props} />
    }
const StyledFlagGw = ({...props}) => {
      return <BaseFlagGw {...props} />
    }
const StyledFlagHk = ({...props}) => {
      return <BaseFlagHk {...props} />
    }
const StyledFlagHn = ({...props}) => {
      return <BaseFlagHn {...props} />
    }
const StyledFlagHr = ({...props}) => {
      return <BaseFlagHr {...props} />
    }
const StyledFlagHt = ({...props}) => {
      return <BaseFlagHt {...props} />
    }
const StyledFlagHu = ({...props}) => {
      return <BaseFlagHu {...props} />
    }
const StyledFlagId = ({...props}) => {
      return <BaseFlagId {...props} />
    }
const StyledFlagIe = ({...props}) => {
      return <BaseFlagIe {...props} />
    }
const StyledFlagIl = ({...props}) => {
      return <BaseFlagIl {...props} />
    }
const StyledFlagIm = ({...props}) => {
      return <BaseFlagIm {...props} />
    }
const StyledFlagIn = ({...props}) => {
      return <BaseFlagIn {...props} />
    }
const StyledFlagIo = ({...props}) => {
      return <BaseFlagIo {...props} />
    }
const StyledFlagIq = ({...props}) => {
      return <BaseFlagIq {...props} />
    }
const StyledFlagIr = ({...props}) => {
      return <BaseFlagIr {...props} />
    }
const StyledFlagIs = ({...props}) => {
      return <BaseFlagIs {...props} />
    }
const StyledFlagIt = ({...props}) => {
      return <BaseFlagIt {...props} />
    }
const StyledFlagJe = ({...props}) => {
      return <BaseFlagJe {...props} />
    }
const StyledFlagJm = ({...props}) => {
      return <BaseFlagJm {...props} />
    }
const StyledFlagJo = ({...props}) => {
      return <BaseFlagJo {...props} />
    }
const StyledFlagJp = ({...props}) => {
      return <BaseFlagJp {...props} />
    }
const StyledFlagKe = ({...props}) => {
      return <BaseFlagKe {...props} />
    }
const StyledFlagKg = ({...props}) => {
      return <BaseFlagKg {...props} />
    }
const StyledFlagKh = ({...props}) => {
      return <BaseFlagKh {...props} />
    }
const StyledFlagKi = ({...props}) => {
      return <BaseFlagKi {...props} />
    }
const StyledFlagKm = ({...props}) => {
      return <BaseFlagKm {...props} />
    }
const StyledFlagKn = ({...props}) => {
      return <BaseFlagKn {...props} />
    }
const StyledFlagKp = ({...props}) => {
      return <BaseFlagKp {...props} />
    }
const StyledFlagKr = ({...props}) => {
      return <BaseFlagKr {...props} />
    }
const StyledFlagKw = ({...props}) => {
      return <BaseFlagKw {...props} />
    }
const StyledFlagKy = ({...props}) => {
      return <BaseFlagKy {...props} />
    }
const StyledFlagKz = ({...props}) => {
      return <BaseFlagKz {...props} />
    }
const StyledFlagLa = ({...props}) => {
      return <BaseFlagLa {...props} />
    }
const StyledFlagLb = ({...props}) => {
      return <BaseFlagLb {...props} />
    }
const StyledFlagLc = ({...props}) => {
      return <BaseFlagLc {...props} />
    }
const StyledFlagLi = ({...props}) => {
      return <BaseFlagLi {...props} />
    }
const StyledFlagLk = ({...props}) => {
      return <BaseFlagLk {...props} />
    }
const StyledFlagLr = ({...props}) => {
      return <BaseFlagLr {...props} />
    }
const StyledFlagLt = ({...props}) => {
      return <BaseFlagLt {...props} />
    }
const StyledFlagLu = ({...props}) => {
      return <BaseFlagLu {...props} />
    }
const StyledFlagLv = ({...props}) => {
      return <BaseFlagLv {...props} />
    }
const StyledFlagLy = ({...props}) => {
      return <BaseFlagLy {...props} />
    }
const StyledFlagMa = ({...props}) => {
      return <BaseFlagMa {...props} />
    }
const StyledFlagMc = ({...props}) => {
      return <BaseFlagMc {...props} />
    }
const StyledFlagMd = ({...props}) => {
      return <BaseFlagMd {...props} />
    }
const StyledFlagMe = ({...props}) => {
      return <BaseFlagMe {...props} />
    }
const StyledFlagMg = ({...props}) => {
      return <BaseFlagMg {...props} />
    }
const StyledFlagMh = ({...props}) => {
      return <BaseFlagMh {...props} />
    }
const StyledFlagMk = ({...props}) => {
      return <BaseFlagMk {...props} />
    }
const StyledFlagMl = ({...props}) => {
      return <BaseFlagMl {...props} />
    }
const StyledFlagMm = ({...props}) => {
      return <BaseFlagMm {...props} />
    }
const StyledFlagMn = ({...props}) => {
      return <BaseFlagMn {...props} />
    }
const StyledFlagMo = ({...props}) => {
      return <BaseFlagMo {...props} />
    }
const StyledFlagMp = ({...props}) => {
      return <BaseFlagMp {...props} />
    }
const StyledFlagMq = ({...props}) => {
      return <BaseFlagMq {...props} />
    }
const StyledFlagMr = ({...props}) => {
      return <BaseFlagMr {...props} />
    }
const StyledFlagMs = ({...props}) => {
      return <BaseFlagMs {...props} />
    }
const StyledFlagMt = ({...props}) => {
      return <BaseFlagMt {...props} />
    }
const StyledFlagMu = ({...props}) => {
      return <BaseFlagMu {...props} />
    }
const StyledFlagMv = ({...props}) => {
      return <BaseFlagMv {...props} />
    }
const StyledFlagMw = ({...props}) => {
      return <BaseFlagMw {...props} />
    }
const StyledFlagMx = ({...props}) => {
      return <BaseFlagMx {...props} />
    }
const StyledFlagMy = ({...props}) => {
      return <BaseFlagMy {...props} />
    }
const StyledFlagMz = ({...props}) => {
      return <BaseFlagMz {...props} />
    }
const StyledFlagNa = ({...props}) => {
      return <BaseFlagNa {...props} />
    }
const StyledFlagNf = ({...props}) => {
      return <BaseFlagNf {...props} />
    }
const StyledFlagNg = ({...props}) => {
      return <BaseFlagNg {...props} />
    }
const StyledFlagNi = ({...props}) => {
      return <BaseFlagNi {...props} />
    }
const StyledFlagNl = ({...props}) => {
      return <BaseFlagNl {...props} />
    }
const StyledFlagNo = ({...props}) => {
      return <BaseFlagNo {...props} />
    }
const StyledFlagNp = ({...props}) => {
      return <BaseFlagNp {...props} />
    }
const StyledFlagNr = ({...props}) => {
      return <BaseFlagNr {...props} />
    }
const StyledFlagNu = ({...props}) => {
      return <BaseFlagNu {...props} />
    }
const StyledFlagOm = ({...props}) => {
      return <BaseFlagOm {...props} />
    }
const StyledFlagPa = ({...props}) => {
      return <BaseFlagPa {...props} />
    }
const StyledFlagPe = ({...props}) => {
      return <BaseFlagPe {...props} />
    }
const StyledFlagPf = ({...props}) => {
      return <BaseFlagPf {...props} />
    }
const StyledFlagPg = ({...props}) => {
      return <BaseFlagPg {...props} />
    }
const StyledFlagPh = ({...props}) => {
      return <BaseFlagPh {...props} />
    }
const StyledFlagPk = ({...props}) => {
      return <BaseFlagPk {...props} />
    }
const StyledFlagPl = ({...props}) => {
      return <BaseFlagPl {...props} />
    }
const StyledFlagPn = ({...props}) => {
      return <BaseFlagPn {...props} />
    }
const StyledFlagPr = ({...props}) => {
      return <BaseFlagPr {...props} />
    }
const StyledFlagPs = ({...props}) => {
      return <BaseFlagPs {...props} />
    }
const StyledFlagPt = ({...props}) => {
      return <BaseFlagPt {...props} />
    }
const StyledFlagPw = ({...props}) => {
      return <BaseFlagPw {...props} />
    }
const StyledFlagPy = ({...props}) => {
      return <BaseFlagPy {...props} />
    }
const StyledFlagQa = ({...props}) => {
      return <BaseFlagQa {...props} />
    }
const StyledFlagRo = ({...props}) => {
      return <BaseFlagRo {...props} />
    }
const StyledFlagRs = ({...props}) => {
      return <BaseFlagRs {...props} />
    }
const StyledFlagRu = ({...props}) => {
      return <BaseFlagRu {...props} />
    }
const StyledFlagRw = ({...props}) => {
      return <BaseFlagRw {...props} />
    }
const StyledFlagSa = ({...props}) => {
      return <BaseFlagSa {...props} />
    }
const StyledFlagSb = ({...props}) => {
      return <BaseFlagSb {...props} />
    }
const StyledFlagSc = ({...props}) => {
      return <BaseFlagSc {...props} />
    }
const StyledFlagSd = ({...props}) => {
      return <BaseFlagSd {...props} />
    }
const StyledFlagSe = ({...props}) => {
      return <BaseFlagSe {...props} />
    }
const StyledFlagSg = ({...props}) => {
      return <BaseFlagSg {...props} />
    }
const StyledFlagSi = ({...props}) => {
      return <BaseFlagSi {...props} />
    }
const StyledFlagSk = ({...props}) => {
      return <BaseFlagSk {...props} />
    }
const StyledFlagSl = ({...props}) => {
      return <BaseFlagSl {...props} />
    }
const StyledFlagSm = ({...props}) => {
      return <BaseFlagSm {...props} />
    }
const StyledFlagSn = ({...props}) => {
      return <BaseFlagSn {...props} />
    }
const StyledFlagSo = ({...props}) => {
      return <BaseFlagSo {...props} />
    }
const StyledFlagSr = ({...props}) => {
      return <BaseFlagSr {...props} />
    }
const StyledFlagSs = ({...props}) => {
      return <BaseFlagSs {...props} />
    }
const StyledFlagSt = ({...props}) => {
      return <BaseFlagSt {...props} />
    }
const StyledFlagSv = ({...props}) => {
      return <BaseFlagSv {...props} />
    }
const StyledFlagSx = ({...props}) => {
      return <BaseFlagSx {...props} />
    }
const StyledFlagSy = ({...props}) => {
      return <BaseFlagSy {...props} />
    }
const StyledFlagSz = ({...props}) => {
      return <BaseFlagSz {...props} />
    }
const StyledFlagTc = ({...props}) => {
      return <BaseFlagTc {...props} />
    }
const StyledFlagTd = ({...props}) => {
      return <BaseFlagTd {...props} />
    }
const StyledFlagTg = ({...props}) => {
      return <BaseFlagTg {...props} />
    }
const StyledFlagTh = ({...props}) => {
      return <BaseFlagTh {...props} />
    }
const StyledFlagTj = ({...props}) => {
      return <BaseFlagTj {...props} />
    }
const StyledFlagTk = ({...props}) => {
      return <BaseFlagTk {...props} />
    }
const StyledFlagTl = ({...props}) => {
      return <BaseFlagTl {...props} />
    }
const StyledFlagTm = ({...props}) => {
      return <BaseFlagTm {...props} />
    }
const StyledFlagTn = ({...props}) => {
      return <BaseFlagTn {...props} />
    }
const StyledFlagTo = ({...props}) => {
      return <BaseFlagTo {...props} />
    }
const StyledFlagTr = ({...props}) => {
      return <BaseFlagTr {...props} />
    }
const StyledFlagTt = ({...props}) => {
      return <BaseFlagTt {...props} />
    }
const StyledFlagTv = ({...props}) => {
      return <BaseFlagTv {...props} />
    }
const StyledFlagTw = ({...props}) => {
      return <BaseFlagTw {...props} />
    }
const StyledFlagTz = ({...props}) => {
      return <BaseFlagTz {...props} />
    }
const StyledFlagUa = ({...props}) => {
      return <BaseFlagUa {...props} />
    }
const StyledFlagUg = ({...props}) => {
      return <BaseFlagUg {...props} />
    }
const StyledFlagUk = ({...props}) => {
      return <BaseFlagUk {...props} />
    }
const StyledFlagUsHi = ({...props}) => {
      return <BaseFlagUsHi {...props} />
    }
const StyledFlagUs = ({...props}) => {
      return <BaseFlagUs {...props} />
    }
const StyledFlagUy = ({...props}) => {
      return <BaseFlagUy {...props} />
    }
const StyledFlagUz = ({...props}) => {
      return <BaseFlagUz {...props} />
    }
const StyledFlagVa = ({...props}) => {
      return <BaseFlagVa {...props} />
    }
const StyledFlagVc = ({...props}) => {
      return <BaseFlagVc {...props} />
    }
const StyledFlagVe = ({...props}) => {
      return <BaseFlagVe {...props} />
    }
const StyledFlagVg = ({...props}) => {
      return <BaseFlagVg {...props} />
    }
const StyledFlagVn = ({...props}) => {
      return <BaseFlagVn {...props} />
    }
const StyledFlagVu = ({...props}) => {
      return <BaseFlagVu {...props} />
    }
const StyledFlagWs = ({...props}) => {
      return <BaseFlagWs {...props} />
    }
const StyledFlagXk = ({...props}) => {
      return <BaseFlagXk {...props} />
    }
const StyledFlagYe = ({...props}) => {
      return <BaseFlagYe {...props} />
    }
const StyledFlagZa = ({...props}) => {
      return <BaseFlagZa {...props} />
    }
const StyledFlagZm = ({...props}) => {
      return <BaseFlagZm {...props} />
    }
const StyledFlagZw = ({...props}) => {
      return <BaseFlagZw {...props} />
    }
const StyledFolder = ({...props}) => {
      return <BaseFolder {...props} />
    }
const StyledGatsbyLogo = ({...props}) => {
      return <BaseGatsbyLogo {...props} />
    }
const StyledGithub = ({...props}) => {
      return <BaseGithub {...props} />
    }
const StyledHome = ({...props}) => {
      return <BaseHome {...props} />
    }
const StyledHumanCell = ({...props}) => {
      return <BaseHumanCell {...props} />
    }
const StyledInfoIco = ({...props}) => {
      return <BaseInfoIco {...props} />
    }
const StyledLink = ({...props}) => {
      return <BaseLink {...props} />
    }
const StyledLogoAniBlack = ({...props}) => {
      return <BaseLogoAniBlack {...props} />
    }
const StyledLogoAniWhite = ({...props}) => {
      return <BaseLogoAniWhite {...props} />
    }
const StyledLogoAnimadoBlanco = ({...props}) => {
      return <BaseLogoAnimadoBlanco {...props} />
    }
const StyledLogoAnimadoNegro = ({...props}) => {
      return <BaseLogoAnimadoNegro {...props} />
    }
const StyledLogoBlack = ({...props}) => {
      return <BaseLogoBlack {...props} />
    }
const StyledLogoWhite = ({...props}) => {
      return <BaseLogoWhite {...props} />
    }
const StyledMagmaLogo = ({...props}) => {
      return <BaseMagmaLogo {...props} />
    }
const StyledMagma = ({...props}) => {
      return <BaseMagma {...props} />
    }
const StyledMapEsAn = ({...props}) => {
      return <BaseMapEsAn {...props} />
    }
const StyledMapEsAr = ({...props}) => {
      return <BaseMapEsAr {...props} />
    }
const StyledMapEsAs = ({...props}) => {
      return <BaseMapEsAs {...props} />
    }
const StyledMapEsCb = ({...props}) => {
      return <BaseMapEsCb {...props} />
    }
const StyledMapEsCl = ({...props}) => {
      return <BaseMapEsCl {...props} />
    }
const StyledMapEsCm = ({...props}) => {
      return <BaseMapEsCm {...props} />
    }
const StyledMapEsCn = ({...props}) => {
      return <BaseMapEsCn {...props} />
    }
const StyledMapEsCt = ({...props}) => {
      return <BaseMapEsCt {...props} />
    }
const StyledMapEsEx = ({...props}) => {
      return <BaseMapEsEx {...props} />
    }
const StyledMapEsGa = ({...props}) => {
      return <BaseMapEsGa {...props} />
    }
const StyledMapEsIb = ({...props}) => {
      return <BaseMapEsIb {...props} />
    }
const StyledMapEsMc = ({...props}) => {
      return <BaseMapEsMc {...props} />
    }
const StyledMapEsMd = ({...props}) => {
      return <BaseMapEsMd {...props} />
    }
const StyledMapEsNc = ({...props}) => {
      return <BaseMapEsNc {...props} />
    }
const StyledMapEsPv = ({...props}) => {
      return <BaseMapEsPv {...props} />
    }
const StyledMapEsRi = ({...props}) => {
      return <BaseMapEsRi {...props} />
    }
const StyledMapEsVc = ({...props}) => {
      return <BaseMapEsVc {...props} />
    }
const StyledMapEs = ({...props}) => {
      return <BaseMapEs {...props} />
    }
const StyledMapEu = ({...props}) => {
      return <BaseMapEu {...props} />
    }
const StyledMapFr = ({...props}) => {
      return <BaseMapFr {...props} />
    }
const StyledMapIt = ({...props}) => {
      return <BaseMapIt {...props} />
    }
const StyledMapNl = ({...props}) => {
      return <BaseMapNl {...props} />
    }
const StyledMapRu = ({...props}) => {
      return <BaseMapRu {...props} />
    }
const StyledMapSe = ({...props}) => {
      return <BaseMapSe {...props} />
    }
const StyledMapUk = ({...props}) => {
      return <BaseMapUk {...props} />
    }
const StyledMapUs = ({...props}) => {
      return <BaseMapUs {...props} />
    }
const StyledMedicalMeeting = ({...props}) => {
      return <BaseMedicalMeeting {...props} />
    }
const StyledMenuClose = ({...props}) => {
      return <BaseMenuClose {...props} />
    }
const StyledMenuOpen = ({...props}) => {
      return <BaseMenuOpen {...props} />
    }
const StyledNotFoundImage = ({...props}) => {
      return <BaseNotFoundImage {...props} />
    }
const StyledNurseTalk = ({...props}) => {
      return <BaseNurseTalk {...props} />
    }
const StyledNurseWithPacient = ({...props}) => {
      return <BaseNurseWithPacient {...props} />
    }
const StyledRedradix = ({...props}) => {
      return <BaseRedradix {...props} />
    }
const StyledRemoteIco = ({...props}) => {
      return <BaseRemoteIco {...props} />
    }
const StyledRepor = ({...props}) => {
      return <BaseRepor {...props} />
    }
const StyledReset = ({...props}) => {
      return <BaseReset {...props} />
    }
const StyledRoundAlert = ({...props}) => {
      return <BaseRoundAlert {...props} />
    }
const StyledSecondCovidContact = ({...props}) => {
      return <BaseSecondCovidContact {...props} />
    }
const StyledSecuoyas = ({...props}) => {
      return <BaseSecuoyas {...props} />
    }
const StyledSevereCaseIcon = ({...props}) => {
      return <BaseSevereCaseIcon {...props} />
    }
const StyledSoftCaseIcon = ({...props}) => {
      return <BaseSoftCaseIcon {...props} />
    }
const StyledSymptonsCough = ({...props}) => {
      return <BaseSymptonsCough {...props} />
    }
const StyledSymptonsDiabetes = ({...props}) => {
      return <BaseSymptonsDiabetes {...props} />
    }
const StyledSymptonsExpectoration = ({...props}) => {
      return <BaseSymptonsExpectoration {...props} />
    }
const StyledSymptonsFever = ({...props}) => {
      return <BaseSymptonsFever {...props} />
    }
const StyledSymptonsHeart = ({...props}) => {
      return <BaseSymptonsHeart {...props} />
    }
const StyledSymptonsHospital = ({...props}) => {
      return <BaseSymptonsHospital {...props} />
    }
const StyledSymptonsHypertension = ({...props}) => {
      return <BaseSymptonsHypertension {...props} />
    }
const StyledSymptonsQuarantine = ({...props}) => {
      return <BaseSymptonsQuarantine {...props} />
    }
const StyledSymptonsUnwell = ({...props}) => {
      return <BaseSymptonsUnwell {...props} />
    }
const StyledSymtonsCough = ({...props}) => {
      return <BaseSymtonsCough {...props} />
    }
const StyledThirdCovidContact = ({...props}) => {
      return <BaseThirdCovidContact {...props} />
    }
const StyledVector = ({...props}) => {
      return <BaseVector {...props} />
    }
const StyledVirusCough = ({...props}) => {
      return <BaseVirusCough {...props} />
    }
const StyledVirusFever = ({...props}) => {
      return <BaseVirusFever {...props} />
    }
const StyledVirusGreenIco = ({...props}) => {
      return <BaseVirusGreenIco {...props} />
    }
const StyledVirusIco = ({...props}) => {
      return <BaseVirusIco {...props} />
    }
const StyledVirusIncubation = ({...props}) => {
      return <BaseVirusIncubation {...props} />
    }
const StyledVirusInfected3079 = ({...props}) => {
      return <BaseVirusInfected3079 {...props} />
    }
const StyledVirusInfectedMen = ({...props}) => {
      return <BaseVirusInfectedMen {...props} />
    }
const StyledVirusInfectedUnder20 = ({...props}) => {
      return <BaseVirusInfectedUnder20 {...props} />
    }
const StyledVirusInfected = ({...props}) => {
      return <BaseVirusInfected {...props} />
    }
const StyledVirusLungDamage = ({...props}) => {
      return <BaseVirusLungDamage {...props} />
    }
const StyledVirusSoreThroath = ({...props}) => {
      return <BaseVirusSoreThroath {...props} />
    }
const StyledVirusSymptoms = ({...props}) => {
      return <BaseVirusSymptoms {...props} />
    }
const StyledVirusWhiteIco = ({...props}) => {
      return <BaseVirusWhiteIco {...props} />
    }
const StyledZoom = ({...props}) => {
      return <BaseZoom {...props} />
    }
const StyledZoomin = ({...props}) => {
      return <BaseZoomin {...props} />
    }
const StyledZoomout = ({...props}) => {
      return <BaseZoomout {...props} />
    }

const Icons = {
accessApi : StyledAccessApi,
alert : StyledAlert,
api : StyledApi,
arrowBottom : StyledArrowBottom,
arrowLeft : StyledArrowLeft,
arrowRight : StyledArrowRight,
arrowTop : StyledArrowTop,
arrow : StyledArrow,
bitbucket : StyledBitbucket,
book : StyledBook,
calendar : StyledCalendar,
chart : StyledChart,
cleanProducts : StyledCleanProducts,
clockBlack : StyledClockBlack,
clock : StyledClock,
contentIndex : StyledContentIndex,
arn : StyledArn,
eProtein : StyledEProtein,
glycoproteicMembrane : StyledGlycoproteicMembrane,
nProtein : StyledNProtein,
sProtein : StyledSProtein,
coronavirusIlu : StyledCoronavirusIlu,
dashboard : StyledDashboard,
dataIco : StyledDataIco,
distancedCat : StyledDistancedCat,
distancedMan : StyledDistancedMan,
distancedWoman : StyledDistancedWoman,
download : StyledDownload,
drag : StyledDrag,
file : StyledFile,
firstCovidContact : StyledFirstCovidContact,
flagOms : StyledFlagOms,
flagAd : StyledFlagAd,
flagAe : StyledFlagAe,
flagAf : StyledFlagAf,
flagAg : StyledFlagAg,
flagAi : StyledFlagAi,
flagAl : StyledFlagAl,
flagAm : StyledFlagAm,
flagAo : StyledFlagAo,
flagAr : StyledFlagAr,
flagAs : StyledFlagAs,
flagAt : StyledFlagAt,
flagAu : StyledFlagAu,
flagAw : StyledFlagAw,
flagAx : StyledFlagAx,
flagAz : StyledFlagAz,
flagBa : StyledFlagBa,
flagBb : StyledFlagBb,
flagBd : StyledFlagBd,
flagBe : StyledFlagBe,
flagBf : StyledFlagBf,
flagBg : StyledFlagBg,
flagBh : StyledFlagBh,
flagBi : StyledFlagBi,
flagBj : StyledFlagBj,
flagBm : StyledFlagBm,
flagBn : StyledFlagBn,
flagBo : StyledFlagBo,
flagBq : StyledFlagBq,
flagBr : StyledFlagBr,
flagBs : StyledFlagBs,
flagBt : StyledFlagBt,
flagBw : StyledFlagBw,
flagBy : StyledFlagBy,
flagBz : StyledFlagBz,
flagCa : StyledFlagCa,
flagCc : StyledFlagCc,
flagCd : StyledFlagCd,
flagCf : StyledFlagCf,
flagCg : StyledFlagCg,
flagCh : StyledFlagCh,
flagCi : StyledFlagCi,
flagCk : StyledFlagCk,
flagCl : StyledFlagCl,
flagCm : StyledFlagCm,
flagCn : StyledFlagCn,
flagCo : StyledFlagCo,
flagCr : StyledFlagCr,
flagCu : StyledFlagCu,
flagCv : StyledFlagCv,
flagCw : StyledFlagCw,
flagCx : StyledFlagCx,
flagCz : StyledFlagCz,
flagDe : StyledFlagDe,
flagDj : StyledFlagDj,
flagDk : StyledFlagDk,
flagDm : StyledFlagDm,
flagDo : StyledFlagDo,
flagDz : StyledFlagDz,
flagEcW : StyledFlagEcW,
flagEc : StyledFlagEc,
flagEe : StyledFlagEe,
flagEg : StyledFlagEg,
flagEh : StyledFlagEh,
flagEr : StyledFlagEr,
flagEsAn : StyledFlagEsAn,
flagEsAr : StyledFlagEsAr,
flagEsAs : StyledFlagEsAs,
flagEsCb : StyledFlagEsCb,
flagEsCe : StyledFlagEsCe,
flagEsCl : StyledFlagEsCl,
flagEsCm : StyledFlagEsCm,
flagEsCn : StyledFlagEsCn,
flagEsCt : StyledFlagEsCt,
flagEsEx : StyledFlagEsEx,
flagEsGa : StyledFlagEsGa,
flagEsIb : StyledFlagEsIb,
flagEsMc : StyledFlagEsMc,
flagEsMd : StyledFlagEsMd,
flagEsMl : StyledFlagEsMl,
flagEsNc : StyledFlagEsNc,
flagEsPv : StyledFlagEsPv,
flagEsRi : StyledFlagEsRi,
flagEsVc : StyledFlagEsVc,
flagEs : StyledFlagEs,
flagEt : StyledFlagEt,
flagEu : StyledFlagEu,
flagFi : StyledFlagFi,
flagFj : StyledFlagFj,
flagFk : StyledFlagFk,
flagFm : StyledFlagFm,
flagFr : StyledFlagFr,
flagGa : StyledFlagGa,
flagGb : StyledFlagGb,
flagGd : StyledFlagGd,
flagGe : StyledFlagGe,
flagGg : StyledFlagGg,
flagGh : StyledFlagGh,
flagGi : StyledFlagGi,
flagGl : StyledFlagGl,
flagGm : StyledFlagGm,
flagGn : StyledFlagGn,
flagGq : StyledFlagGq,
flagGr : StyledFlagGr,
flagGt : StyledFlagGt,
flagGu : StyledFlagGu,
flagGw : StyledFlagGw,
flagHk : StyledFlagHk,
flagHn : StyledFlagHn,
flagHr : StyledFlagHr,
flagHt : StyledFlagHt,
flagHu : StyledFlagHu,
flagId : StyledFlagId,
flagIe : StyledFlagIe,
flagIl : StyledFlagIl,
flagIm : StyledFlagIm,
flagIn : StyledFlagIn,
flagIo : StyledFlagIo,
flagIq : StyledFlagIq,
flagIr : StyledFlagIr,
flagIs : StyledFlagIs,
flagIt : StyledFlagIt,
flagJe : StyledFlagJe,
flagJm : StyledFlagJm,
flagJo : StyledFlagJo,
flagJp : StyledFlagJp,
flagKe : StyledFlagKe,
flagKg : StyledFlagKg,
flagKh : StyledFlagKh,
flagKi : StyledFlagKi,
flagKm : StyledFlagKm,
flagKn : StyledFlagKn,
flagKp : StyledFlagKp,
flagKr : StyledFlagKr,
flagKw : StyledFlagKw,
flagKy : StyledFlagKy,
flagKz : StyledFlagKz,
flagLa : StyledFlagLa,
flagLb : StyledFlagLb,
flagLc : StyledFlagLc,
flagLi : StyledFlagLi,
flagLk : StyledFlagLk,
flagLr : StyledFlagLr,
flagLt : StyledFlagLt,
flagLu : StyledFlagLu,
flagLv : StyledFlagLv,
flagLy : StyledFlagLy,
flagMa : StyledFlagMa,
flagMc : StyledFlagMc,
flagMd : StyledFlagMd,
flagMe : StyledFlagMe,
flagMg : StyledFlagMg,
flagMh : StyledFlagMh,
flagMk : StyledFlagMk,
flagMl : StyledFlagMl,
flagMm : StyledFlagMm,
flagMn : StyledFlagMn,
flagMo : StyledFlagMo,
flagMp : StyledFlagMp,
flagMq : StyledFlagMq,
flagMr : StyledFlagMr,
flagMs : StyledFlagMs,
flagMt : StyledFlagMt,
flagMu : StyledFlagMu,
flagMv : StyledFlagMv,
flagMw : StyledFlagMw,
flagMx : StyledFlagMx,
flagMy : StyledFlagMy,
flagMz : StyledFlagMz,
flagNa : StyledFlagNa,
flagNf : StyledFlagNf,
flagNg : StyledFlagNg,
flagNi : StyledFlagNi,
flagNl : StyledFlagNl,
flagNo : StyledFlagNo,
flagNp : StyledFlagNp,
flagNr : StyledFlagNr,
flagNu : StyledFlagNu,
flagOm : StyledFlagOm,
flagPa : StyledFlagPa,
flagPe : StyledFlagPe,
flagPf : StyledFlagPf,
flagPg : StyledFlagPg,
flagPh : StyledFlagPh,
flagPk : StyledFlagPk,
flagPl : StyledFlagPl,
flagPn : StyledFlagPn,
flagPr : StyledFlagPr,
flagPs : StyledFlagPs,
flagPt : StyledFlagPt,
flagPw : StyledFlagPw,
flagPy : StyledFlagPy,
flagQa : StyledFlagQa,
flagRo : StyledFlagRo,
flagRs : StyledFlagRs,
flagRu : StyledFlagRu,
flagRw : StyledFlagRw,
flagSa : StyledFlagSa,
flagSb : StyledFlagSb,
flagSc : StyledFlagSc,
flagSd : StyledFlagSd,
flagSe : StyledFlagSe,
flagSg : StyledFlagSg,
flagSi : StyledFlagSi,
flagSk : StyledFlagSk,
flagSl : StyledFlagSl,
flagSm : StyledFlagSm,
flagSn : StyledFlagSn,
flagSo : StyledFlagSo,
flagSr : StyledFlagSr,
flagSs : StyledFlagSs,
flagSt : StyledFlagSt,
flagSv : StyledFlagSv,
flagSx : StyledFlagSx,
flagSy : StyledFlagSy,
flagSz : StyledFlagSz,
flagTc : StyledFlagTc,
flagTd : StyledFlagTd,
flagTg : StyledFlagTg,
flagTh : StyledFlagTh,
flagTj : StyledFlagTj,
flagTk : StyledFlagTk,
flagTl : StyledFlagTl,
flagTm : StyledFlagTm,
flagTn : StyledFlagTn,
flagTo : StyledFlagTo,
flagTr : StyledFlagTr,
flagTt : StyledFlagTt,
flagTv : StyledFlagTv,
flagTw : StyledFlagTw,
flagTz : StyledFlagTz,
flagUa : StyledFlagUa,
flagUg : StyledFlagUg,
flagUk : StyledFlagUk,
flagUsHi : StyledFlagUsHi,
flagUs : StyledFlagUs,
flagUy : StyledFlagUy,
flagUz : StyledFlagUz,
flagVa : StyledFlagVa,
flagVc : StyledFlagVc,
flagVe : StyledFlagVe,
flagVg : StyledFlagVg,
flagVn : StyledFlagVn,
flagVu : StyledFlagVu,
flagWs : StyledFlagWs,
flagXk : StyledFlagXk,
flagYe : StyledFlagYe,
flagZa : StyledFlagZa,
flagZm : StyledFlagZm,
flagZw : StyledFlagZw,
folder : StyledFolder,
gatsbyLogo : StyledGatsbyLogo,
github : StyledGithub,
home : StyledHome,
humanCell : StyledHumanCell,
infoIco : StyledInfoIco,
link : StyledLink,
logoAniBlack : StyledLogoAniBlack,
logoAniWhite : StyledLogoAniWhite,
logoAnimadoBlanco : StyledLogoAnimadoBlanco,
logoAnimadoNegro : StyledLogoAnimadoNegro,
logoBlack : StyledLogoBlack,
logoWhite : StyledLogoWhite,
magmaLogo : StyledMagmaLogo,
magma : StyledMagma,
mapEsAn : StyledMapEsAn,
mapEsAr : StyledMapEsAr,
mapEsAs : StyledMapEsAs,
mapEsCb : StyledMapEsCb,
mapEsCl : StyledMapEsCl,
mapEsCm : StyledMapEsCm,
mapEsCn : StyledMapEsCn,
mapEsCt : StyledMapEsCt,
mapEsEx : StyledMapEsEx,
mapEsGa : StyledMapEsGa,
mapEsIb : StyledMapEsIb,
mapEsMc : StyledMapEsMc,
mapEsMd : StyledMapEsMd,
mapEsNc : StyledMapEsNc,
mapEsPv : StyledMapEsPv,
mapEsRi : StyledMapEsRi,
mapEsVc : StyledMapEsVc,
mapEs : StyledMapEs,
mapEu : StyledMapEu,
mapFr : StyledMapFr,
mapIt : StyledMapIt,
mapNl : StyledMapNl,
mapRu : StyledMapRu,
mapSe : StyledMapSe,
mapUk : StyledMapUk,
mapUs : StyledMapUs,
medicalMeeting : StyledMedicalMeeting,
menuClose : StyledMenuClose,
menuOpen : StyledMenuOpen,
notFoundImage : StyledNotFoundImage,
nurseTalk : StyledNurseTalk,
nurseWithPacient : StyledNurseWithPacient,
redradix : StyledRedradix,
remoteIco : StyledRemoteIco,
repor : StyledRepor,
reset : StyledReset,
roundAlert : StyledRoundAlert,
secondCovidContact : StyledSecondCovidContact,
secuoyas : StyledSecuoyas,
severeCaseIcon : StyledSevereCaseIcon,
softCaseIcon : StyledSoftCaseIcon,
symptonsCough : StyledSymptonsCough,
symptonsDiabetes : StyledSymptonsDiabetes,
symptonsExpectoration : StyledSymptonsExpectoration,
symptonsFever : StyledSymptonsFever,
symptonsHeart : StyledSymptonsHeart,
symptonsHospital : StyledSymptonsHospital,
symptonsHypertension : StyledSymptonsHypertension,
symptonsQuarantine : StyledSymptonsQuarantine,
symptonsUnwell : StyledSymptonsUnwell,
symtonsCough : StyledSymtonsCough,
thirdCovidContact : StyledThirdCovidContact,
vector : StyledVector,
virusCough : StyledVirusCough,
virusFever : StyledVirusFever,
virusGreenIco : StyledVirusGreenIco,
virusIco : StyledVirusIco,
virusIncubation : StyledVirusIncubation,
virusInfected3079 : StyledVirusInfected3079,
virusInfectedMen : StyledVirusInfectedMen,
virusInfectedUnder20 : StyledVirusInfectedUnder20,
virusInfected : StyledVirusInfected,
virusLungDamage : StyledVirusLungDamage,
virusSoreThroath : StyledVirusSoreThroath,
virusSymptoms : StyledVirusSymptoms,
virusWhiteIco : StyledVirusWhiteIco,
zoom : StyledZoom,
zoomin : StyledZoomin,
zoomout : StyledZoomout,
}

const IcnSystem = ({ name, ...props }) => {

  // if editor ask for an icon that's not in the system
  if(!Icons[name]) return Icons['notFoundImage'](props)
  
  return Icons[name](props)
}

export { StyledAccessApi as AccessApi }
export { StyledAlert as Alert }
export { StyledApi as Api }
export { StyledArrowBottom as ArrowBottom }
export { StyledArrowLeft as ArrowLeft }
export { StyledArrowRight as ArrowRight }
export { StyledArrowTop as ArrowTop }
export { StyledArrow as Arrow }
export { StyledBitbucket as Bitbucket }
export { StyledBook as Book }
export { StyledCalendar as Calendar }
export { StyledChart as Chart }
export { StyledCleanProducts as CleanProducts }
export { StyledClockBlack as ClockBlack }
export { StyledClock as Clock }
export { StyledContentIndex as ContentIndex }
export { StyledArn as Arn }
export { StyledEProtein as EProtein }
export { StyledGlycoproteicMembrane as GlycoproteicMembrane }
export { StyledNProtein as NProtein }
export { StyledSProtein as SProtein }
export { StyledCoronavirusIlu as CoronavirusIlu }
export { StyledDashboard as Dashboard }
export { StyledDataIco as DataIco }
export { StyledDistancedCat as DistancedCat }
export { StyledDistancedMan as DistancedMan }
export { StyledDistancedWoman as DistancedWoman }
export { StyledDownload as Download }
export { StyledDrag as Drag }
export { StyledFile as File }
export { StyledFirstCovidContact as FirstCovidContact }
export { StyledFlagOms as FlagOms }
export { StyledFlagAd as FlagAd }
export { StyledFlagAe as FlagAe }
export { StyledFlagAf as FlagAf }
export { StyledFlagAg as FlagAg }
export { StyledFlagAi as FlagAi }
export { StyledFlagAl as FlagAl }
export { StyledFlagAm as FlagAm }
export { StyledFlagAo as FlagAo }
export { StyledFlagAr as FlagAr }
export { StyledFlagAs as FlagAs }
export { StyledFlagAt as FlagAt }
export { StyledFlagAu as FlagAu }
export { StyledFlagAw as FlagAw }
export { StyledFlagAx as FlagAx }
export { StyledFlagAz as FlagAz }
export { StyledFlagBa as FlagBa }
export { StyledFlagBb as FlagBb }
export { StyledFlagBd as FlagBd }
export { StyledFlagBe as FlagBe }
export { StyledFlagBf as FlagBf }
export { StyledFlagBg as FlagBg }
export { StyledFlagBh as FlagBh }
export { StyledFlagBi as FlagBi }
export { StyledFlagBj as FlagBj }
export { StyledFlagBm as FlagBm }
export { StyledFlagBn as FlagBn }
export { StyledFlagBo as FlagBo }
export { StyledFlagBq as FlagBq }
export { StyledFlagBr as FlagBr }
export { StyledFlagBs as FlagBs }
export { StyledFlagBt as FlagBt }
export { StyledFlagBw as FlagBw }
export { StyledFlagBy as FlagBy }
export { StyledFlagBz as FlagBz }
export { StyledFlagCa as FlagCa }
export { StyledFlagCc as FlagCc }
export { StyledFlagCd as FlagCd }
export { StyledFlagCf as FlagCf }
export { StyledFlagCg as FlagCg }
export { StyledFlagCh as FlagCh }
export { StyledFlagCi as FlagCi }
export { StyledFlagCk as FlagCk }
export { StyledFlagCl as FlagCl }
export { StyledFlagCm as FlagCm }
export { StyledFlagCn as FlagCn }
export { StyledFlagCo as FlagCo }
export { StyledFlagCr as FlagCr }
export { StyledFlagCu as FlagCu }
export { StyledFlagCv as FlagCv }
export { StyledFlagCw as FlagCw }
export { StyledFlagCx as FlagCx }
export { StyledFlagCz as FlagCz }
export { StyledFlagDe as FlagDe }
export { StyledFlagDj as FlagDj }
export { StyledFlagDk as FlagDk }
export { StyledFlagDm as FlagDm }
export { StyledFlagDo as FlagDo }
export { StyledFlagDz as FlagDz }
export { StyledFlagEcW as FlagEcW }
export { StyledFlagEc as FlagEc }
export { StyledFlagEe as FlagEe }
export { StyledFlagEg as FlagEg }
export { StyledFlagEh as FlagEh }
export { StyledFlagEr as FlagEr }
export { StyledFlagEsAn as FlagEsAn }
export { StyledFlagEsAr as FlagEsAr }
export { StyledFlagEsAs as FlagEsAs }
export { StyledFlagEsCb as FlagEsCb }
export { StyledFlagEsCe as FlagEsCe }
export { StyledFlagEsCl as FlagEsCl }
export { StyledFlagEsCm as FlagEsCm }
export { StyledFlagEsCn as FlagEsCn }
export { StyledFlagEsCt as FlagEsCt }
export { StyledFlagEsEx as FlagEsEx }
export { StyledFlagEsGa as FlagEsGa }
export { StyledFlagEsIb as FlagEsIb }
export { StyledFlagEsMc as FlagEsMc }
export { StyledFlagEsMd as FlagEsMd }
export { StyledFlagEsMl as FlagEsMl }
export { StyledFlagEsNc as FlagEsNc }
export { StyledFlagEsPv as FlagEsPv }
export { StyledFlagEsRi as FlagEsRi }
export { StyledFlagEsVc as FlagEsVc }
export { StyledFlagEs as FlagEs }
export { StyledFlagEt as FlagEt }
export { StyledFlagEu as FlagEu }
export { StyledFlagFi as FlagFi }
export { StyledFlagFj as FlagFj }
export { StyledFlagFk as FlagFk }
export { StyledFlagFm as FlagFm }
export { StyledFlagFr as FlagFr }
export { StyledFlagGa as FlagGa }
export { StyledFlagGb as FlagGb }
export { StyledFlagGd as FlagGd }
export { StyledFlagGe as FlagGe }
export { StyledFlagGg as FlagGg }
export { StyledFlagGh as FlagGh }
export { StyledFlagGi as FlagGi }
export { StyledFlagGl as FlagGl }
export { StyledFlagGm as FlagGm }
export { StyledFlagGn as FlagGn }
export { StyledFlagGq as FlagGq }
export { StyledFlagGr as FlagGr }
export { StyledFlagGt as FlagGt }
export { StyledFlagGu as FlagGu }
export { StyledFlagGw as FlagGw }
export { StyledFlagHk as FlagHk }
export { StyledFlagHn as FlagHn }
export { StyledFlagHr as FlagHr }
export { StyledFlagHt as FlagHt }
export { StyledFlagHu as FlagHu }
export { StyledFlagId as FlagId }
export { StyledFlagIe as FlagIe }
export { StyledFlagIl as FlagIl }
export { StyledFlagIm as FlagIm }
export { StyledFlagIn as FlagIn }
export { StyledFlagIo as FlagIo }
export { StyledFlagIq as FlagIq }
export { StyledFlagIr as FlagIr }
export { StyledFlagIs as FlagIs }
export { StyledFlagIt as FlagIt }
export { StyledFlagJe as FlagJe }
export { StyledFlagJm as FlagJm }
export { StyledFlagJo as FlagJo }
export { StyledFlagJp as FlagJp }
export { StyledFlagKe as FlagKe }
export { StyledFlagKg as FlagKg }
export { StyledFlagKh as FlagKh }
export { StyledFlagKi as FlagKi }
export { StyledFlagKm as FlagKm }
export { StyledFlagKn as FlagKn }
export { StyledFlagKp as FlagKp }
export { StyledFlagKr as FlagKr }
export { StyledFlagKw as FlagKw }
export { StyledFlagKy as FlagKy }
export { StyledFlagKz as FlagKz }
export { StyledFlagLa as FlagLa }
export { StyledFlagLb as FlagLb }
export { StyledFlagLc as FlagLc }
export { StyledFlagLi as FlagLi }
export { StyledFlagLk as FlagLk }
export { StyledFlagLr as FlagLr }
export { StyledFlagLt as FlagLt }
export { StyledFlagLu as FlagLu }
export { StyledFlagLv as FlagLv }
export { StyledFlagLy as FlagLy }
export { StyledFlagMa as FlagMa }
export { StyledFlagMc as FlagMc }
export { StyledFlagMd as FlagMd }
export { StyledFlagMe as FlagMe }
export { StyledFlagMg as FlagMg }
export { StyledFlagMh as FlagMh }
export { StyledFlagMk as FlagMk }
export { StyledFlagMl as FlagMl }
export { StyledFlagMm as FlagMm }
export { StyledFlagMn as FlagMn }
export { StyledFlagMo as FlagMo }
export { StyledFlagMp as FlagMp }
export { StyledFlagMq as FlagMq }
export { StyledFlagMr as FlagMr }
export { StyledFlagMs as FlagMs }
export { StyledFlagMt as FlagMt }
export { StyledFlagMu as FlagMu }
export { StyledFlagMv as FlagMv }
export { StyledFlagMw as FlagMw }
export { StyledFlagMx as FlagMx }
export { StyledFlagMy as FlagMy }
export { StyledFlagMz as FlagMz }
export { StyledFlagNa as FlagNa }
export { StyledFlagNf as FlagNf }
export { StyledFlagNg as FlagNg }
export { StyledFlagNi as FlagNi }
export { StyledFlagNl as FlagNl }
export { StyledFlagNo as FlagNo }
export { StyledFlagNp as FlagNp }
export { StyledFlagNr as FlagNr }
export { StyledFlagNu as FlagNu }
export { StyledFlagOm as FlagOm }
export { StyledFlagPa as FlagPa }
export { StyledFlagPe as FlagPe }
export { StyledFlagPf as FlagPf }
export { StyledFlagPg as FlagPg }
export { StyledFlagPh as FlagPh }
export { StyledFlagPk as FlagPk }
export { StyledFlagPl as FlagPl }
export { StyledFlagPn as FlagPn }
export { StyledFlagPr as FlagPr }
export { StyledFlagPs as FlagPs }
export { StyledFlagPt as FlagPt }
export { StyledFlagPw as FlagPw }
export { StyledFlagPy as FlagPy }
export { StyledFlagQa as FlagQa }
export { StyledFlagRo as FlagRo }
export { StyledFlagRs as FlagRs }
export { StyledFlagRu as FlagRu }
export { StyledFlagRw as FlagRw }
export { StyledFlagSa as FlagSa }
export { StyledFlagSb as FlagSb }
export { StyledFlagSc as FlagSc }
export { StyledFlagSd as FlagSd }
export { StyledFlagSe as FlagSe }
export { StyledFlagSg as FlagSg }
export { StyledFlagSi as FlagSi }
export { StyledFlagSk as FlagSk }
export { StyledFlagSl as FlagSl }
export { StyledFlagSm as FlagSm }
export { StyledFlagSn as FlagSn }
export { StyledFlagSo as FlagSo }
export { StyledFlagSr as FlagSr }
export { StyledFlagSs as FlagSs }
export { StyledFlagSt as FlagSt }
export { StyledFlagSv as FlagSv }
export { StyledFlagSx as FlagSx }
export { StyledFlagSy as FlagSy }
export { StyledFlagSz as FlagSz }
export { StyledFlagTc as FlagTc }
export { StyledFlagTd as FlagTd }
export { StyledFlagTg as FlagTg }
export { StyledFlagTh as FlagTh }
export { StyledFlagTj as FlagTj }
export { StyledFlagTk as FlagTk }
export { StyledFlagTl as FlagTl }
export { StyledFlagTm as FlagTm }
export { StyledFlagTn as FlagTn }
export { StyledFlagTo as FlagTo }
export { StyledFlagTr as FlagTr }
export { StyledFlagTt as FlagTt }
export { StyledFlagTv as FlagTv }
export { StyledFlagTw as FlagTw }
export { StyledFlagTz as FlagTz }
export { StyledFlagUa as FlagUa }
export { StyledFlagUg as FlagUg }
export { StyledFlagUk as FlagUk }
export { StyledFlagUsHi as FlagUsHi }
export { StyledFlagUs as FlagUs }
export { StyledFlagUy as FlagUy }
export { StyledFlagUz as FlagUz }
export { StyledFlagVa as FlagVa }
export { StyledFlagVc as FlagVc }
export { StyledFlagVe as FlagVe }
export { StyledFlagVg as FlagVg }
export { StyledFlagVn as FlagVn }
export { StyledFlagVu as FlagVu }
export { StyledFlagWs as FlagWs }
export { StyledFlagXk as FlagXk }
export { StyledFlagYe as FlagYe }
export { StyledFlagZa as FlagZa }
export { StyledFlagZm as FlagZm }
export { StyledFlagZw as FlagZw }
export { StyledFolder as Folder }
export { StyledGatsbyLogo as GatsbyLogo }
export { StyledGithub as Github }
export { StyledHome as Home }
export { StyledHumanCell as HumanCell }
export { StyledInfoIco as InfoIco }
export { StyledLink as Link }
export { StyledLogoAniBlack as LogoAniBlack }
export { StyledLogoAniWhite as LogoAniWhite }
export { StyledLogoAnimadoBlanco as LogoAnimadoBlanco }
export { StyledLogoAnimadoNegro as LogoAnimadoNegro }
export { StyledLogoBlack as LogoBlack }
export { StyledLogoWhite as LogoWhite }
export { StyledMagmaLogo as MagmaLogo }
export { StyledMagma as Magma }
export { StyledMapEsAn as MapEsAn }
export { StyledMapEsAr as MapEsAr }
export { StyledMapEsAs as MapEsAs }
export { StyledMapEsCb as MapEsCb }
export { StyledMapEsCl as MapEsCl }
export { StyledMapEsCm as MapEsCm }
export { StyledMapEsCn as MapEsCn }
export { StyledMapEsCt as MapEsCt }
export { StyledMapEsEx as MapEsEx }
export { StyledMapEsGa as MapEsGa }
export { StyledMapEsIb as MapEsIb }
export { StyledMapEsMc as MapEsMc }
export { StyledMapEsMd as MapEsMd }
export { StyledMapEsNc as MapEsNc }
export { StyledMapEsPv as MapEsPv }
export { StyledMapEsRi as MapEsRi }
export { StyledMapEsVc as MapEsVc }
export { StyledMapEs as MapEs }
export { StyledMapEu as MapEu }
export { StyledMapFr as MapFr }
export { StyledMapIt as MapIt }
export { StyledMapNl as MapNl }
export { StyledMapRu as MapRu }
export { StyledMapSe as MapSe }
export { StyledMapUk as MapUk }
export { StyledMapUs as MapUs }
export { StyledMedicalMeeting as MedicalMeeting }
export { StyledMenuClose as MenuClose }
export { StyledMenuOpen as MenuOpen }
export { StyledNotFoundImage as NotFoundImage }
export { StyledNurseTalk as NurseTalk }
export { StyledNurseWithPacient as NurseWithPacient }
export { StyledRedradix as Redradix }
export { StyledRemoteIco as RemoteIco }
export { StyledRepor as Repor }
export { StyledReset as Reset }
export { StyledRoundAlert as RoundAlert }
export { StyledSecondCovidContact as SecondCovidContact }
export { StyledSecuoyas as Secuoyas }
export { StyledSevereCaseIcon as SevereCaseIcon }
export { StyledSoftCaseIcon as SoftCaseIcon }
export { StyledSymptonsCough as SymptonsCough }
export { StyledSymptonsDiabetes as SymptonsDiabetes }
export { StyledSymptonsExpectoration as SymptonsExpectoration }
export { StyledSymptonsFever as SymptonsFever }
export { StyledSymptonsHeart as SymptonsHeart }
export { StyledSymptonsHospital as SymptonsHospital }
export { StyledSymptonsHypertension as SymptonsHypertension }
export { StyledSymptonsQuarantine as SymptonsQuarantine }
export { StyledSymptonsUnwell as SymptonsUnwell }
export { StyledSymtonsCough as SymtonsCough }
export { StyledThirdCovidContact as ThirdCovidContact }
export { StyledVector as Vector }
export { StyledVirusCough as VirusCough }
export { StyledVirusFever as VirusFever }
export { StyledVirusGreenIco as VirusGreenIco }
export { StyledVirusIco as VirusIco }
export { StyledVirusIncubation as VirusIncubation }
export { StyledVirusInfected3079 as VirusInfected3079 }
export { StyledVirusInfectedMen as VirusInfectedMen }
export { StyledVirusInfectedUnder20 as VirusInfectedUnder20 }
export { StyledVirusInfected as VirusInfected }
export { StyledVirusLungDamage as VirusLungDamage }
export { StyledVirusSoreThroath as VirusSoreThroath }
export { StyledVirusSymptoms as VirusSymptoms }
export { StyledVirusWhiteIco as VirusWhiteIco }
export { StyledZoom as Zoom }
export { StyledZoomin as Zoomin }
export { StyledZoomout as Zoomout }

export const iconList = [
  "AccessApi","Alert","Api","ArrowBottom","ArrowLeft","ArrowRight","ArrowTop","Arrow","Bitbucket","Book","Calendar","Chart","CleanProducts","ClockBlack","Clock","ContentIndex","Arn","EProtein","GlycoproteicMembrane","NProtein","SProtein","CoronavirusIlu","Dashboard","DataIco","DistancedCat","DistancedMan","DistancedWoman","Download","Drag","File","FirstCovidContact","FlagOms","FlagAd","FlagAe","FlagAf","FlagAg","FlagAi","FlagAl","FlagAm","FlagAo","FlagAr","FlagAs","FlagAt","FlagAu","FlagAw","FlagAx","FlagAz","FlagBa","FlagBb","FlagBd","FlagBe","FlagBf","FlagBg","FlagBh","FlagBi","FlagBj","FlagBm","FlagBn","FlagBo","FlagBq","FlagBr","FlagBs","FlagBt","FlagBw","FlagBy","FlagBz","FlagCa","FlagCc","FlagCd","FlagCf","FlagCg","FlagCh","FlagCi","FlagCk","FlagCl","FlagCm","FlagCn","FlagCo","FlagCr","FlagCu","FlagCv","FlagCw","FlagCx","FlagCz","FlagDe","FlagDj","FlagDk","FlagDm","FlagDo","FlagDz","FlagEcW","FlagEc","FlagEe","FlagEg","FlagEh","FlagEr","FlagEsAn","FlagEsAr","FlagEsAs","FlagEsCb","FlagEsCe","FlagEsCl","FlagEsCm","FlagEsCn","FlagEsCt","FlagEsEx","FlagEsGa","FlagEsIb","FlagEsMc","FlagEsMd","FlagEsMl","FlagEsNc","FlagEsPv","FlagEsRi","FlagEsVc","FlagEs","FlagEt","FlagEu","FlagFi","FlagFj","FlagFk","FlagFm","FlagFr","FlagGa","FlagGb","FlagGd","FlagGe","FlagGg","FlagGh","FlagGi","FlagGl","FlagGm","FlagGn","FlagGq","FlagGr","FlagGt","FlagGu","FlagGw","FlagHk","FlagHn","FlagHr","FlagHt","FlagHu","FlagId","FlagIe","FlagIl","FlagIm","FlagIn","FlagIo","FlagIq","FlagIr","FlagIs","FlagIt","FlagJe","FlagJm","FlagJo","FlagJp","FlagKe","FlagKg","FlagKh","FlagKi","FlagKm","FlagKn","FlagKp","FlagKr","FlagKw","FlagKy","FlagKz","FlagLa","FlagLb","FlagLc","FlagLi","FlagLk","FlagLr","FlagLt","FlagLu","FlagLv","FlagLy","FlagMa","FlagMc","FlagMd","FlagMe","FlagMg","FlagMh","FlagMk","FlagMl","FlagMm","FlagMn","FlagMo","FlagMp","FlagMq","FlagMr","FlagMs","FlagMt","FlagMu","FlagMv","FlagMw","FlagMx","FlagMy","FlagMz","FlagNa","FlagNf","FlagNg","FlagNi","FlagNl","FlagNo","FlagNp","FlagNr","FlagNu","FlagOm","FlagPa","FlagPe","FlagPf","FlagPg","FlagPh","FlagPk","FlagPl","FlagPn","FlagPr","FlagPs","FlagPt","FlagPw","FlagPy","FlagQa","FlagRo","FlagRs","FlagRu","FlagRw","FlagSa","FlagSb","FlagSc","FlagSd","FlagSe","FlagSg","FlagSi","FlagSk","FlagSl","FlagSm","FlagSn","FlagSo","FlagSr","FlagSs","FlagSt","FlagSv","FlagSx","FlagSy","FlagSz","FlagTc","FlagTd","FlagTg","FlagTh","FlagTj","FlagTk","FlagTl","FlagTm","FlagTn","FlagTo","FlagTr","FlagTt","FlagTv","FlagTw","FlagTz","FlagUa","FlagUg","FlagUk","FlagUsHi","FlagUs","FlagUy","FlagUz","FlagVa","FlagVc","FlagVe","FlagVg","FlagVn","FlagVu","FlagWs","FlagXk","FlagYe","FlagZa","FlagZm","FlagZw","Folder","GatsbyLogo","Github","Home","HumanCell","InfoIco","Link","LogoAniBlack","LogoAniWhite","LogoAnimadoBlanco","LogoAnimadoNegro","LogoBlack","LogoWhite","MagmaLogo","Magma","MapEsAn","MapEsAr","MapEsAs","MapEsCb","MapEsCl","MapEsCm","MapEsCn","MapEsCt","MapEsEx","MapEsGa","MapEsIb","MapEsMc","MapEsMd","MapEsNc","MapEsPv","MapEsRi","MapEsVc","MapEs","MapEu","MapFr","MapIt","MapNl","MapRu","MapSe","MapUk","MapUs","MedicalMeeting","MenuClose","MenuOpen","NotFoundImage","NurseTalk","NurseWithPacient","Redradix","RemoteIco","Repor","Reset","RoundAlert","SecondCovidContact","Secuoyas","SevereCaseIcon","SoftCaseIcon","SymptonsCough","SymptonsDiabetes","SymptonsExpectoration","SymptonsFever","SymptonsHeart","SymptonsHospital","SymptonsHypertension","SymptonsQuarantine","SymptonsUnwell","SymtonsCough","ThirdCovidContact","Vector","VirusCough","VirusFever","VirusGreenIco","VirusIco","VirusIncubation","VirusInfected3079","VirusInfectedMen","VirusInfectedUnder20","VirusInfected","VirusLungDamage","VirusSoreThroath","VirusSymptoms","VirusWhiteIco","Zoom","Zoomin","Zoomout"
]

export default IcnSystem
 